webpackJsonp([1],{

/***/ "5PDQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5UXz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5aCn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8csR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DN8u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GdIk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JAIY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02796314","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("oXGk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3a0bff0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("JAIY")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13cf244c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("Z1YF")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-13cf244c"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2d63fc6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"},on:{"click":_vm.toggleContents}},[_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("jsA2")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-b2d63fc6"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d48a67d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("DN8u")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-6d48a67d"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0878514e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("r8RT")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c2f03a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("5UXz")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bdf4d00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("5aCn")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: []
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-562d7af2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("8csR")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ea834c1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("vvnJ")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6be6e2d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("OT+5")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cad3ed6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('p',{staticClass:"contents-item__text--title"},[_vm._v(_vm._s(_vm.page[0].title))]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("GdIk")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage', 'showContents']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd893e96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("UhHM")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36934d9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("UxE6")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-277a16ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b1b3a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("Tnot")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b767d08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("UrMh")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-405171cd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("aKuC")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-405171cd"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fd40fbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n                            c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n                            c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n                            h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n                            c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n                            M123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n                            c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n                            c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n                            c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n                            c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n                            c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n                            c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n                            C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n                            c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n                            c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n                            c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n                            L154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("TKcf")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa23382e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("kxw3")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7504e64e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{attrs:{"to":_vm.nextPageURI,"classes":"navigation-link--next"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("5PDQ")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/document.js


var _ref;

/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "UEFA Direct - Issue 199",
  "shortTitle": "",
  "description": "",
  "width": 698,
  "height": 909,
  "currentLanguage": "EN",
  "languages": [{
    code: "EN",
    text: "English",
    href: "https://uefadirect.uefa.com/199/en"
  }, {
    code: "FR",
    text: "French",
    href: "https://uefadirect.uefa.com/199/fr"
  }, {
    code: "DE",
    text: "German",
    href: "https://uefadirect.uefa.com/199/de"
  }],
  "basePath": "/199/en",
  // "basePath": "",
  "companyLogo": "1-logo.png",
  "publishURL": "https://uefadirect.uefa.com/199/en/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "downloadPath": '',
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": true,
    "editionsEnabled": true,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {}
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScaleC 1-logo\" style=\"top:2px; left:574px;\" src=\"\n        /199/en/static/_content/1-logo.png\">\n        <img class=\"halfScale 1-number\" style=\"top:111px;right:-12px;\" src=\"\n        /199/en/static/_content/1-no-1.png\">\n        <img class=\"halfScale 1-title\" style=\"top:747px;left:100px;\" src=\"\n        /199/en/static/_content/1-title-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim.fromTo(cOf(\"1-logo\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.8)\n          .fromTo(cOf(\"1-number\"), 0.6, {opacity:0, y:30}, {opacity:1, y:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(cOf(\"1-title\"), 0.6, {opacity:0, y:60}, {opacity:1, y:0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n      }\n      ",
    "searchText": "No. 199  FOOTBALL CAME HOME"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [(_ref = {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "undefined"
  }, defineProperty_default()(_ref, "content", "\n        <img class=\"halfScale 3-title-1\" style=\"top:294px; left:70px;\" src=\"/199/en/static/_content/3-title-1.png\">\n        <img class=\"halfScaleC 3-image-1\" style=\"top:14px; left:3px;\" src=\"/199/en/static/_content/3-image-1.png\">\n        <img class=\"halfScale 3-text-1\" style=\"top:227px; left:87px;\" src=\"/199/en/static/_content/3-text-1.png\">\n      "), defineProperty_default()(_ref, "script", "\n        function onPageEnter() {\n          pg3Anim = new TimelineMax();\n          pg3Anim.fromTo(cOf(\"3-title-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"3-image-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, \"-=0.3\")\n          .fromTo(cOf(\"3-text-1\"), 0.6, {opacity:0, y:30}, {opacity:1, y:0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg3Anim.stop();\n        }\n      "), defineProperty_default()(_ref, "searchText", "EDITORIAL  Aleksander Čeferin UEFA President  A LEGACY TO CHERISH… AND PROTECT  A  s UEFA Women’s EURO 2022 drew closer, there was a fervent hope that the tournament would be a resounding success and take women’s football to exciting new heights. Now, as we take stock of July’s enthralling events in England, we can say with every justification that our expectations were not only completely fulfilled – they were in fact surpassed in remarkable fashion. It was a EURO for the ages. Records were rewritten across the board, with impressive new benchmarks registered that will hopefully add further impetus to the growth of the women’s game across Europe. Moreover, the tournament had a refreshingly positive and festive feel, with fans generating a diverse, vibrant and enthusiastic atmosphere around the matches. Everyone joined together as one to share in the unrivalled joy of our beautiful sport. The final at Wembley Stadium provided a fittingly memorable climax to a competition that offered football of the highest calibre. Congratulations to England, magnificent tournament hosts and worthy first-time champions on home soil after overcoming the outstanding challenge presented by Germany. Together, the finalists delivered a combative and dramatic encounter that captivated the 87,192 spectators present – a record attendance for a women’s or men’s EURO final tournament match. As the dust settles, the European football community has already started work on maximising the important momentum that the tournament brought to women’s football. New expectations sit high on all of our agendas. Each member association must implement effective strategies to build on the positive image left by the EURO – with special emphasis, among many others, on increasing participation levels among women and girls. On our side, UEFA will continue to support the implementation of Time for Action – our five-year strategy for the women’s game in Europe, which has already had a profound impact across the continent. That means offering associations every incentive to make sustainable progress by investing resources and reinforcing women’s football development activities.  The Women’s EURO has left us with much to savour and a host of unforgettable memories. But it is now essential that all of us who have the well-being of women’s football at heart work together tirelessly to ensure that the legacy of a magical month in England is never allowed to fall into neglect. The future rests in our own hands.  UEFA DIRECT • Q3 2022 – 03"), _ref)], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 4-title-1\" style=\"top:129px; left:58px;\" src=\"/199/en/static/_content/4-title-1.png\">\n        <img class=\"halfScaleC 4-logo-1\" style=\"top:195px; left:26px;\" src=\"/199/en/static/_content/4-logo-1.png\">\n    \n        <div class=\"addContentLink\" style=\"top: 486px; left: 211px; width: 416px; height: 62px;\" onclick=\"Publish.goToPage(8)\"></div>\n        <div class=\"addContentLink\" style=\"top: 569px; left: 210px; width: 200px; height: 73px;\" onclick=\"Publish.goToPage(06)\"></div>\n        <div class=\"addContentLink\" style=\"top: 643px; left: 210px; width: 200px; height: 70px;\" onclick=\"Publish.goToPage(24)\"></div>\n        <div class=\"addContentLink\" style=\"top: 714px; left: 210px; width: 200px; height: 83px;\" onclick=\"Publish.goToPage(26)\"></div>\n        <div class=\"addContentLink\" style=\"top: 798px; left: 210px; width: 200px; height: 53px;\" onclick=\"Publish.goToPage(28)\"></div>\n\n        <div class=\"addContentLink\" style=\"top: 569px; left: 426px; width: 212px; height: 63px;\" onclick=\"Publish.goToPage(36)\"></div>\n        <div class=\"addContentLink\" style=\"top: 633px; left: 426px; width: 212px; height: 57px;\" onclick=\"Publish.goToPage(46)\"></div>\n        <div class=\"addContentLink\" style=\"top: 690px; left: 426px; width: 212px; height: 58px;\" onclick=\"Publish.goToPage(48)\"></div>\n        <div class=\"addContentLink\" style=\"top: 748px; left: 426px; width: 212px; height: 41px;\" onclick=\"Publish.goToPage(55)\"></div>\n        <div class=\"addContentLink\" style=\"top: 788px; left: 426px; width: 212px; height: 62px;\" onclick=\"Publish.goToPage(70)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n          pg4Anim.fromTo(cOf(\"4-title-1\"), 0.6, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"4-logo-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7), onComplete: addContentLinks}, \"-=0.3\")\n        }\n  \n        function onPageLeave() {\n          pg4Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "CONTENTS  IN THIS ISSUE Q3 2022  Official publication of the Union of European Football Associations  Chief editor: Emmanuel Deconche Deputy chief editor: Dominique Maurer Chief writer: Mark Chaplin Subeditor: Susan Angel External contributors: Simon Hart (pages 6-7, 30-35, 42-43) Graham Turner (pages 36-39) Peter Glynn (pages 44-45, 46-47) Julien Hernandez (pages 48-51) André Vieli (page 70) Translations: UEFA Language Services Production: Touchline Printing: Artgraphic Cavin, CH-1422 Grandson Editorial deadline: 12 September 2022 Photos: Getty Images unless mentioned  08 A summer to remember  Tightly fought, top-quality matches, a relaxed family atmosphere and supporters galore: a look back in pictures on a record-breaking Women’s EURO 2022 in England.  06 Baroness Sue Campbell The director of women’s football at the English Football Association reflects on the astounding success of EURO 2022 and its expected legacy in the host nation.  24 Impeccable organisation An overview of the phenomenal organisational teamwork inside and outside the EURO 2022 stadiums.  26 Interview  Printed Matter  Anne Rei, chair of the UEFA Women’s Football Committee, explains how EURO 2022 was a game changer in the development of women’s football.  36 Club competitions UEFA holds its annual awards ceremony in Istanbul alongside the draw ceremonies to launch the major men’s club competitions.  46 Women’s Futsal EURO Spain retain their title at the second Women’s Futsal EURO.  48 2022 World Cup 13 European teams prepare to conquer the world.  55 News from member associations  myclimate.org/01-22-503966  28 The stats behind Women’s EURO 2022 How the 95 goals were scored.  70 Hans Bangerter Remembering Hans Bangerter, UEFA general secretary from 1960 to 1988, who has died at the age of 98."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" style=\"top: 457px; left: 57px; width: 276px; height: 78px;\" onclick=\"Publish.goToPage(52)\"></div>\n        <div class=\"addContentLink\" style=\"top: 451px; left: 332px; width: 309px; height: 72px;\" onclick=\"Publish.goToPage(30)\"></div>\n        <div class=\"addContentLink\" style=\"top: 786px; left: 57px; width: 303px; height: 58px;\" onclick=\"Publish.goToPage(40)\"></div>\n        <div class=\"addContentLink\" style=\"top: 796px; left: 375px; width: 264px; height: 58px;\" onclick=\"Publish.goToPage(42)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "CONTENTS  52 Pitch mapping tool  UEFA develops a platform mapping more than 250,000 pitches across Europe.  40 UEFA Super Cup  Young footballers with cerebral palsy enjoy an experience to remember thanks to the UEFA Foundation for Children.  30 The Technician  A study of Women’s EURO tournaments since 1997 highlights significant markers of the tactical and technical improvement of the women’s game in Europe.  42 Under-19 championships  After a three-year COVID-enforced absence, the women’s and men’s European Under-19 championships take place again. UEFA DIRECT • Q3 2022 – 05"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 6-title-1\" style=\"top:145px; left:252px;\" src=\"/199/en/static/_content/6-title-1.png\">\n        <img class=\"halfScale 6-sub-1\" style=\"top:296px; left:252px;\" src=\"/199/en/static/_content/6-sub-1.png\">\n      ",
    "script": "\n      \n      function onPageEnter() {\n        pg6Anim = new TimelineMax();\n        pg6Anim.fromTo(cOf(\"6-title-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"6-sub-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg6Anim.stop();\n      }\n      ",
    "searchText": "“PEOPLE TELL ME, ‘YOU’VE BROUGHT THE BEAUTIFUL GAME BACK’” Baroness Sue Campbell, director of women’s football at the English Football Association (The FA), reflects on England’s triumph – and what comes next.  “I  f I could take a pound for everybody who’s stopped me to say how brilliant they think the women’s game is … and I’m not just talking about England, I’m talking about the skill level, the way the women play, their respect for the referee, their toughness in terms of if they get kicked, they just get up and get on.” Baroness Sue Campbell, director of women’s football at the English Football Association, is sharing some of her highlights of a summer to remember. For her, as for so many followers of English football, this will be remembered as the summer of a home triumph at the UEFA Women’s EURO, a summer of record attendances and unprecedented interest. Yet Campbell finds reasons for pride and satisfaction beyond the patriotic swell of an England success. “What am I proudest of? First that women’s football has demonstrated to a massive audience that it’s a brilliant, competitive game, and really excellent to watch. “Number two is that we welcomed an accumulative attendance of just under 575,000 [more than double that of the previous EURO] and that’s wonderful, though the really great part of it was the atmosphere in the grounds and the warmth and friendliness. I was watching people going into the final with babies and was thinking, ‘This means people feel it’s family-friendly, it’s going to be a celebration’.” She cites also the enthusiasm of the tournament volunteers, numbering over 2,300 in total, as she recalls an encounter with two of them in the car park at England’s semi-final in Sheffield. 06 – UEFA DIRECT • Q3 2022  “We had a train strike the following day and neither of them knew how they were going to get home but neither of them cared!” she recalls. “They were just so in the moment.” With a nod to Chris Bryant, the head of tournament delivery, she also praises “the organisation of it, the promotion of it, the marketing [which] really touched people. We’ve probably done more for women’s sport and women’s football in that one EURO than any policies I might have written or any advocacy I might do or any discussions I might have. It’s done more for the women’s game than you could possibly have hoped. I hope that’s felt in Europe and not just in England.” Capitalising on the momentum What happens next is another matter to consider. The next challenge, she attests, is to “capitalise on” the momentum generated. “We went on sale for our next England game at Wembley, which is a friendly against the USA, and we sold out within 24 hours.” At the level of the Barclays Women’s Super League (WSL), meanwhile, there has been “a massive uplift in application for tickets”. On the steps taken to prepare for this harvest, Baroness Campbell explains how in 2021 The FA created a digital football hub – EnglandFootball.com – to ensure clear access to the game. “If you wanted to play, volunteer, coach, referee or just watch, we created a hub that you could literally go into and it showed you your nearest club and how you could do it,” she says. Come the EURO, she continues, “we promoted it heavily off the back of every  game, with the message that ‘if you’ve enjoyed this, go to your WSL or Championship or local club to enjoy watching football’.” To spread the word further, The FA has increased by 20% this season’s marketing budget in order “to help market the games more effectively working in partnership with the clubs”. She believes women’s football can benefit from its “different culture”, elaborating: “People say to me, ‘You’ve brought the beautiful game back’, meaning this is like football used to be. “Just like men’s football, it’s a great product but it’s definitely a different experience and that’s what we need to market. It’s a place you can happily bring your children, a place where you don’t have segregation; it’s a family experience. “Our players are relatable – they’re very ordinary people who have just made their dreams come true. They aren’t paid superstar salaries, they don’t live in superstar homes, they’re ordinary people. And they take their responsibility massively seriously about legacy.” Ensuring the legacy The question of legacy came to the fore following England’s triumph with the publishing of an open letter by the squad to Rishi Sunak and Liz Truss, the two candidates to succeed Boris Johnson as UK prime minister, in which they asked for better access to football for girls in schools. Currently, 63% of all schools in England offer equal access through girls’ football in PE lessons. The FA’s strategic objectives include 75% access by 2024."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "INTERVIEW  Thanks to its Barclays Girls’ Football School Partnerships, a nationwide network of schools offering girls’ football, The FA has already begun to make a difference, as Baroness Campbell elaborates. “We’ve worked really hard since 2017/18 to build an infrastructure which Barclays, our sponsor, helps us to fund. It gives us an advocate in each family of schools at local level. That advocate then has access to all our resources. We’re in 12,000 schools and there are 21–22,000 so we’re in over half already.”  Baroness Sue Campbell is delighted at the unprecedented public interest generated by the tournament in England.  Baroness Campbell says: “We were on the bus back from a celebration event when Lotte Wubben-Moy came to see me and said: ‘Sue, we really want to do something beyond just hoping there is a legacy.’ And I said: ‘What do you want to do?’ And she said: ‘We really want for no girl to show up in school and be told she can’t do football.’  “They’ve been on mainstream television talking about it,” she continues, “and they feel responsible, having inspired a generation of girls to want to play this game, that these girls shouldn’t be prevented from playing because football isn’t available to them. They aren’t going to do this for a week, they’re going to pursue this until they can satisfy themselves that they’ve made that difference.”  The longer-term and broader goals As for the future for the Barclays Women’s Super League and FA Women’s Championship, the long-term aim is for a stand-alone league structure, yet Baroness Campbell considers it essential that, for the time being, The FA continues to provide a guiding hand. “It’s like a 400m race. We’ve come out of the start really well and are going up the back straight but everybody knows a 400m race is won on the top bend usually – and we’re just entering that top bend. “Managing that top bend so we can run down that home straight successfully is what we’re in the business of doing. We absolutely want this to ultimately be club-run but having invested so heavily in the game, we don’t want to just cast it off and hope it survives. We’ll invest a lot of money in the next few years in providing better support right from the bottom of the Championship all the way through, developing and employing good people who really know women’s sport and really understand elite women’s performance. As we do that, we can start to create a fully professional double league.” And finally from Baroness Campbell, a reminder about the broader goal: to inspire, and to improve lives. For the one-time PE teacher in an inner-city school in Manchester, this is paramount. “We want girls to realise you don’t have to be one specific shape or size. You can get joy, you can build great friendships, you can develop your physical well-being, you can develop your emotional well-being, you can build social links – we want people to understand that sport is a pretty powerful tool. “We want to play our part in helping a generation of women to be healthy, happy and to enjoy life.” UEFA DIRECT • Q3 2022 – 07"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "08 – UEFA DIRECT • Q3 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 9-title-1\" style=\"top:154px; left:368px;\" src=\"/199/en/static/_content/9-title-1.png\">\n        <img class=\"halfScale 9-sub-1\" style=\"top:278px; left:368px;\" src=\"/199/en/static/_content/9-sub-1.png\">\n\n        <a href=\"https://www.uefa.tv/video/vod/379650/\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:383px;left:349px;\" src=\"/199/en/static/_content/9-play-1.png\">\n        </a>\n\n        <div class=\"addContentLink\" style=\"top:414px;left:424px;width:39px;height:16px;\">\n          <a href=\"/199/en/static/_content/results-womens-euro.pdf\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n      \n      function onPageEnter() {\n        pg9Anim = new TimelineMax();\n        pg9Anim.fromTo(cOf(\"9-title-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"9-sub-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg9Anim.stop();\n        removeContentLinks()\n      }\n      ",
    "searchText": "BREAKING ALL THE RECORDS IN ENGLAND Women’s EURO 2022 will be remembered for the sensational action on the field of play and the atmosphere in the stadiums. It also set new records both on the pitch as well as in terms of attendance and viewing figures. Results  UEFA DIRECT • Q3 2022 – 09"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "1. In the group stage, it took Switzerland only five minutes to put two goals past Portugal goalkeeper Inês Pereira. Switzerland’s joy was short-lived, however, with Portugal bringing the score level in the second half. 2. The first goal at Women’s EURO 2022 was scored by England’s Beth Mead against Austria, watched by a crowd of 69,000 at Old Trafford, sending the Lionesses on their way to their first title. 3. By reaching the quarter-finals, Austria (Marina Georgieva up against Northern Ireland’s Marissa Callaghan in their teams’ group match) confirmed their European status after their semi-final appearance in 2017.  1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "2  3 UEFA DIRECT • Q3 2022 – 11"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Italy and Iceland’s 1-1 draw lost both teams points and closed the doors to the quarter-finals to both of them.  12 – UEFA DIRECT • Q3 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "1. Tine De Caigny celebrates the goal that put Belgium through to their first Women’s EURO quarter-finals, at Italy’s expense. 2. In Rotherham, reigning European champions the Netherlands came unstuck against France in the quarter-finals. 3. A friendly flag-waving contest between German and French supporters at the semi-final in Milton Keynes.  2  1 14 – UEFA DIRECT • Q3 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "3  UEFA DIRECT • Q3 2022 – 15"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "1. An urban setting for Denmark v Spain in Brentford. 2. Germany’s Alexandra Popp scored both of the goals that defeated France in the semi-final played in Milton Keynes.  2"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Chloe Kelly scores England’s winner in the 110th minute of the final.  18 – UEFA DIRECT • Q3 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "UEFA DIRECT • Q2 2022 – 21"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "RESULTS Group A 06/07/22  Trafford  England - Austria  1-0  07/07/22  Southampton  Norway - Northern Ireland  4-1  11/07/22  Southampton  Austria - Northern Ireland  2-0  11/07/22  Brighton & Hove  England - Norway  8-0  15/07/22  Southampton  Northern Ireland - England  0-5  15/07/22  Brighton & Hove  Austria - Norway  1-0  08/07/22  Milton Keynes  Spain - Finland  4-1  08/07/22  London  Germany - Denmark  4-0  12/07/22  Milton Keynes  Denmark - Finland  1-0  12/07/22  London  Germany - Spain  2-0  16/07/22  Milton Keynes  Finland - Germany  0-3  16/07/22  London  Denmark - Spain  0-1  09/07/22  Wigan & Leigh  Portugal - Switzerland  2-2  09/07/22  Sheffield  Netherlands - Sweden  1-1  13/07/22  Sheffield  Sweden - Switzerland  2-1  13/07/22  Wigan & Leigh  Netherlands - Portugal  3-2  17/07/22  Sheffield  Switzerland - Netherlands  1-4  17/07/22  Wigan & Leigh  Sweden - Portugal  5-0  10/07/22  Manchester  Belgium - Iceland  1-1  10/07/22  Rotherham  France - Italy  5-1  14/07/22  Manchester  Italy - Iceland  1-1  14/07/22  Rotherham  France - Belgium  2-1  18/07/22  Rotherham  Iceland - France  1-1  18/07/22  Manchester  Italy - Belgium  0-1  Group B  Group C  Group D  Quarter-finals  Semi-finals  P  W  D  L  Pts  England  3  3  0  0  9  2  Austria  3  2  0  1  6  3  Norway  3  1  0  2  3  4  Northern Ireland  3  0  0  3  0  Standings  P  W  D  L  Pts  1  Germany  3  3  0  0  9  2  Spain  3  2  0  1  6  3  Denmark  3  1  0  2  3  4  Finland  3  0  0  3  0  Standings  P  W  D  L  Pts  1  Sweden  3  2  1  0  7  2  Netherlands  3  2  1  0  7  3  Switzerland  3  0  1  2  1  4  Portugal  3  0  1  2  1  Standings  P  W  D  L  Pts  France  3  2  1  0  7  1 2  Belgium  3  1  1  1  4  3  Iceland  3  0  3  0  3  4  Italy  3  0  1  2  1  Semi-finals Final  20/07/22  26/07/22  22/07/22  Sheffield England - Sweden 4-0  England - Germany 2-1*  Quarter-finals 21/07/22  31/07/22 London  Brighton & Hove England - Spain 2-1*  Wigan & Leigh Sweden - Belgium 1-0  Standings 1  27/07/22 Milton Keynes Germany - France 2-1  London Germany - Austria 2-0  23/07/22 Rotherham France - Netherlands 1-0*  *after extra time  UEFA DIRECT • Q3 2022 – 23"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 24-title-1\" style=\"top:97px; left:143px;\" src=\"/199/en/static/_content/24-title-1.png\">\n        <img class=\"halfScale 24-sub-1\" style=\"top:187px; left:27px;\" src=\"/199/en/static/_content/24-sub-1.png\">\n\n        <img class=\"halfScaleC 24-box\" style=\"top:175px; left:-91px;\" src=\"/199/en/static/_content/24-box-1.png\">\n        <img class=\"halfScaleC 24-box\" style=\"top:503px; left:-46px;\" src=\"/199/en/static/_content/24-box-2.png\">\n        <img class=\"halfScaleC 24-box\" style=\"top:347px; left:130px;\" src=\"/199/en/static/_content/24-box-3.png\">\n        \n      ",
    "script": "\n        function onPageEnter() {\n          pg24Anim = new TimelineMax();\n          pg24Anim.fromTo(cOf(\"24-title-1\"), 0.6, {opacity:0, y:-30}, {opacity:1, y:0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"24-sub-1\"), 0.6, {opacity:0, x:-30}, {opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .staggerFromTo(cOf(\"24-box\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.3, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg24Anim.stop();\n        }\n      ",
    "searchText": "The team behind every match Staging the biggest UEFA Women’s EURO ever required phenomenal teamwork. Here we look at how the tournament’s organisation set new records inside and outside the stadiums.  Doping control • The largest-ever anti-doping programme for a Women’s EURO saw UEFA collect 208 samples before and during the tournament. All tested negative. • UEFA delivered anti-doping education and awareness resources to each team.  Accessibility for all  Media operations  • UEFA reserved over 3,000 tickets for supporters using wheelchairs, each with a companion seat.  • Onsite: 570+ journalists, photographers and non-rights holding broadcasters.  • An online audio-descriptive commentary system allowed blind and partially-sighted fans to follow the action.  • Online: 1,500+ videos, photos, data items and news stories shared on UEFA’s media channel.  24 – UEFA DIRECT • Q3 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScaleC 25-box\" style=\"top:-101px; left:-42px;\" src=\"/199/en/static/_content/25-box-1.png\">\n        <img class=\"halfScaleC 25-box\" style=\"top:-34px; left:184px;\" src=\"/199/en/static/_content/25-box-2.png\">\n        <img class=\"halfScaleC 25-box\" style=\"top:174px; left:198px;\" src=\"/199/en/static/_content/25-box-3.png\">\n        <img class=\"halfScaleC 25-box\" style=\"top:379px; left:414px;\" src=\"/199/en/static/_content/25-box-4.png\">\n        <img class=\"halfScaleC 25-box\" style=\"top:554px; left:180px;\" src=\"/199/en/static/_content/25-box-5.png\">\n        <img class=\"halfScaleC 25-box\" style=\"top:665px; left:-41px;\" src=\"/199/en/static/_content/25-box-6.png\">\n        \n      ",
    "script": "\n        function onPageEnter() {\n          pg25Anim = new TimelineMax();\n          pg25Anim.staggerFromTo(cOf(\"25-box\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.3, 1.4)\n        }\n\n        function onPageLeave() {\n          pg25Anim.stop();\n        }\n      ",
    "searchText": "Host broadcasting • UEFA delivered live coverage and editorial services to 60+ broadcast partners worldwide. • Most watched Women’s EURO ever: projected 365 million live viewership. • The final between England and Germany attracted 50 million viewers.  Volunteers • 2,300+ volunteers ensured a fantastic spectator experience at all stadiums and host cities. • Ticketing and accreditation services played a critical role in the tournament’s organisational success story.  Social media • 453 million cumulative social interactions • TikTok 38.7% • Twitter 21.1% • 590,000 new followers across UEFA’s women’s football accounts on social media.  Host cities • 217,000+ people attended fan parties. • 19,200 spectators joined fan walks to the matches.  • 574,875 fans attended the 31 matches, surpassing the previous record of 240,055 before the end of the group stage. • 87,192: England v Germany set a new record for a UEFA EURO match – women’s and men’s.  English FA legacy programme • 400,000+ new opportunities for girls and women to play football in the host cities. • 7,900 new registrations at clubs. • 14,600 girls and women playing the game recreationally for the first time. The FA  Attendance figures"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 26-title-1\" style=\"top:122px; left:252px;\" src=\"/199/en/static/_content/26-title-1.png\">\n        <img class=\"halfScale 26-sub-1\" style=\"top:241px; left:252px;\" src=\"/199/en/static/_content/26-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg26Anim = new TimelineMax();\n          pg26Anim.fromTo(cOf(\"26-title-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"26-sub-1\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg26Anim.stop();\n        }\n      ",
    "searchText": "‘THE BAR HAS BEEN RAISED TO A NEW LEVEL’  Anne Rei, chair of the UEFA Women's Football Committee and general secretary of the Estonian Football Association.  What’s your overriding feeling about the Women’s EURO from the perspective of European women’s football and its future? To everyone’s great delight, the event was a resounding success, creating potentially huge momentum for the women’s game. Completely new expectations have emerged that we now have to manage, especially in terms of preparing and organising the next tournament in 2025. The bar has been raised to a new level, and we must adjust to this. What aspects of the EURO surprised you most? My abiding sensation is that the tournament had a great purity and sincerity about it – and I was thrilled by the wonderfully positive atmosphere as well. There was a tremendous diversity of people at the matches – for instance, we saw a lot of families in the stands, showing their joy and creating a festive environment. There was a sense of community – everyone enjoying being together, sharing the beautiful game in a safe and happy environment. The atmosphere at the final at Wembley was unbelievable, something never to forget! Record attendances, record TV viewing figures – the tournament set notable new benchmarks. It’s important to build on the significant legacy that’s been left behind, but how can this be achieved? 26 – UEFA DIRECT • Q3 2022  UEFA’s hopes that the Women’s EURO in England would set impressive new standards for women’s football were realised in spectacular fashion. The chair of the UEFA Women’s Football Committee, Anne Rei, shares her impressions of the tournament and looks at the road ahead for the women’s game in Europe. I think that everybody within women’s football needs to play their part and create significant change, from the grassroots level to the elite. We must make use of this new momentum and capitalise on our various strategies, visions and plans. Every national association must work with their specific strategies and use the positive image created by the EURO to support their activities and achieve their objectives. It’s clear to me that the UEFA women’s football strategy launched in 2019 has had a major impact on the development of women's football. With its clear objectives, targets and actions, the strategy has laid the foundations to professionalise our working structures and build the best possible platform to help the women’s game thrive in the coming years. Alongside this strategy, UEFA is also fulfilling a key role investing considerable resources in women’s football to help it move onwards and upwards. How can Europe’s national associations contribute to keeping the momentum going? I think it’s extremely important that they drive participation – investing in programmes and activities to keep and increase the number of women and girls in the game. They should guarantee suitable environments for coaching at all levels, while also increasing the quality and quantity of coaches, male and female, at grassroots and elite levels. The FAs should strive to improve the quality and quantity of female referees at all levels as well, and I see plenty of potential in encouraging men’s clubs  everywhere to embrace women’s football and set up their own teams. Given these objectives, there is no reason why we can’t meet UEFA’s target to raise the number of women and girls playing football across Europe from 1.25 million, as was the case in 2019, to the projected figure of 2.5 million in 2024. What can UEFA, as European football’s umbrella body, do in turn to help its member associations in this respect?"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "INTERVIEW  There are a number of possibilities. Firstly, we can create regular playing opportunities for talented girls and move towards the professionalisation of elite women’s football. We must also encourage FAs to recognise women’s football as a dual-career sport. UEFA has to emphasise to its member associations that they need to implement a specific women’s football strategy in their countries… and I’m pleased to say that this latter aspect is already bearing fruit – 44% of European FAs had a women’s football strategy in 2019, and that percentage rose to 67% in 2021. Secondly, UEFA can foster an overall understanding of the women’s game by continuing to provide regular insights into areas such as participation, medicine and financial aspects. UEFA recently published The Business Case for Women’s Football, a practical report underlining the potential for growth in the European women’s club and league game over the next decade. This is a perfect example of what UEFA’s role should be. And let’s not forget UEFA’s special women’s football development programmes for coaches, officials and referees, and the support being given through the UEFA HatTrick programme’s incentives for women’s football. These initiatives are also having an profound impact on the progress of the women’s  game throughout the continent. It’s extremely gratifying to see how UEFA is devoting such priority attention and resources to women’s football and its various elements. This is absolutely essential for the future. There are still large discrepancies in quality between teams in Europe. What can be done to help countries still at the development stage to be more competitive? This is one of the most critical issues at the moment. Within the UEFA Women’s Football Committee, we’re discussing how we can transform the competitions and nurture the right environment for development. We must aim for more competitively equal matches at all levels. It’s an ongoing process. We’ve already reshaped the girls’ Under-17 and Under-19 qualifying formats, and this move has had a positive impact in terms of sporting balance. We’ve received initial positive feedback from associations and coaches. How do you judge the quality and value of UEFA’s promotional activities for women’s football? I really believe they’ve hit their targets. They’ve generated an atmosphere of ‘fandom’ around women’s football and increased the visibility of the women’s  Setting remarkable new standards and breaking records across the board, Anne Rei believes that EURO 2022 has created huge momentum for the women's game.  game, especially in the specific targeted age groups. Their activities have changed perceptions – and, in particular, they’ve helped create role models for girls to try to emulate. I’m personally not the target group for these activities! However, I’ve seen the numbers and heard the feedback – all of which are extremely positive and promising for the future. You’re not only chair of the UEFA Women’s Football Committee, you’re also general secretary of the Estonian Football Association. The number of women currently in leadership positions within European national football associations is encouraging, but there’s scope for even greater numbers. How can this be achieved? Currently, we have three female association presidents – in England, Iceland and Norway – and five female general secretaries or CEOs – besides myself, in France, Germany, Iceland and Portugal. Their presence provides ample proof that women can make a significant impact within the game – not only on the field, but also as part of the key decision-making processes off it. This is a huge step forward and, personally, I’m delighted to see that big traditional footballing countries are showing the way. I also know that within many FAs, female representation on boards or in leadership roles has increased significantly in recent times. Doors are certainly opening… It's crystal clear to me that the more women there are in leadership positions, the more doors will be opened for others to join them. There’s definitely been a shift in perceptions – and, in my opinion, the evolution taking place has been fostered in no small part by the success of women’s football on the field. And, of course, by implementing educational, leadership and mentoring programmes, we can give crucial backing to women in football who are striving to take their next professional steps. I strongly believe that the example being set currently will serve as an immense source of inspiration for women to play a full part in shaping the future of the game on this continent. UEFA DIRECT • Q3 2022 – 27"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 28-title-1\" style=\"top:131px; left:58px;\" src=\"/199/en/static/_content/28-title-1.png\">\n        <img class=\"halfScale 28-sub-1\" style=\"top:207px; left:59px;\" src=\"/199/en/static/_content/28-sub-1.png\">\n\n        <a href=\"https://www.uefa.tv/video/vod/379766/\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:249px;left:41px;\" src=\"/199/en/static/_content/28-play-1.png\">\n        </a>\n      ",
    "script": "\n      \n      function onPageEnter() {\n        pg28Anim = new TimelineMax();\n        pg28Anim.fromTo(cOf(\"28-title-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"28-sub-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg28Anim.stop();\n        removeContentLinks()\n      }\n      ",
    "searchText": "FOR THE RECORD  THE STATS BEHIND WOMEN’S EURO 2022 UEFA Direct looks at some of the statistics and figures found in the UEFA Women’s EURO 2022 technical report to see how the goals were scored in the game-changing and record-breaking tournament. All the goals  95 75  68 56  50 40  35  Goals scored  3.33  2.33  2.66  1997  2001  2005  15  15  15  3.00  3.07  2.24  2.19  2009  2013  2017  2022  25  25 31  31  Matches played  Average goals per match  TOP SCORERS Player  Goals  Minutes played  Beth Mead (ENG)  6  450  Alexandra Popp (GER)  6  361  Alessia Russo (ENG)  4  265  Grace Geyoro (FRA)  3  360  Lina Magull (GER)  3  336  Alexandra Popp shot locations  Goal  Beth Mead shot locations  28 – UEFA DIRECT • Q3 2022  No goal"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "FOR THE RECORD  GOAL TYPE  62%  38%  Groups  KO  Total  Combinations  6  -  6  Crosses  14  5  19  Open-play goals  Cut-backs  5  2  7  Set-play goals  Through passes  5  1  6  Long balls  3  -  3  Individual action  3  1  4  Shots from outside box  5  2  7  Open-play goals  Defensive errors  4  1  5  Own goals  3  1  4  Total  48  13  61  0  1  2  3  4  5  Sweden  Netherlands Set-play goals scored  England Spain  Set-play goals conceded  Portugal  Set-play goals 13  3  16  Direct free-kicks  1  -  1  Norway Switzerland  -  8  Throw-ins  1  -  1  Penalties  7  1  8  Total  30  4  34  Overall total  78  17  95  *includes 2 own goals following a set play  France  Following a corner  8  7  Germany  Iceland  Indirect free-kicks  6  Belgium  Austria Northern Ireland Italy Denmark Finland  GOALS TIME 21 18 15  14  10 8 5 3 1 1-15 min  16-30 min  31-45 min  45+ min  46-60 min  61-75 min  76-90 min  90+ min  91-120 min  UEFA DIRECT • Q3 2022 – 29"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 30-title-1\" style=\"top:183px; left:33px;\" src=\"/199/en/static/_content/30-title-1.png\">\n        <img class=\"halfScale 30-sub-1\" style=\"top:438px; left:59px;\" src=\"/199/en/static/_content/30-sub-1.png\">\n      ",
    "script": "\n      \n      function onPageEnter() {\n        pg30Anim = new TimelineMax();\n        pg30Anim.fromTo(cOf(\"30-title-1\"), 0.6, {opacity:0, x:-30}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"30-sub-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg30Anim.stop();\n        removeContentLinks()\n      }\n      ",
    "searchText": "THE TECHNICIAN  WOMEN’S EURO EVOLUTION SIGNALS RISING STANDARDS A study of past Women’s EURO tournaments highlights improvements in passing, pressing and possession as better coaching and fitness help the elite women’s game develop.  Q  uality, not quantity. This short slogan could feature in a broad summary of the key trends identified in a longitudinal study of the development of elite women’s football across the last seven UEFA Women’s EUROs. The study, commissioned by UEFA using data from StatsBomb, assesses every Women’s EURO from 1997 up to and including this summer’s final tournament in England and it has  found several significant markers of improvement. For a start, teams have become more selective in their shooting and pressing – shooting from better locations and pressing higher in the final third – both of which are signs of improved levels of organisation and fitness. When it comes to pressing, for instance, the average number of pressures has risen to 152 per game – compared with 112 in the first Women’s EURO of this century in 2001.  The impact of better coaching is evident too in the reduced number of turnovers of possession, which means that when teams get the ball, they are passing it better and making more profitable use of their spells of possession. UEFA hopes that by identifying the important trends in the women’s international game, it can help the coaching community to build on the success of the 2022 finals. Here we reflect on the principal talking points raised by the study.  SHOOTING – Goals rise as shots fall Goals vs expected goals  3.04  3 2.64  3.21  3.07  2.96 2.72  2.77  2.33  1997 Goals  2.24  2001  2005  2009  xG  30 – UEFA DIRECT • Q3 2022  2.69  2.59  2013  2.19  2.34  2017  2022  Goals v expected goals (xG) The 2022 tournament averaged 3.07 goals per game, which aligns with the wider trend for higher-scoring matches seen across football generally. The expected goals (xG) per game, meanwhile, has decreased since 1997. As the bar chart shows, for the 1997 finals, the xG was 3 and the goals total was 2.33. Indeed, the xG figure was greater than the goals total in four of the six previous tournaments in the study, whereas in 2022 we saw the opposite, with an xG of 2.69, which suggests an improvement in finishing technique.Shooting was one of the chief areas of focus of the study and the evidence points to players having become more selective when it comes to taking shots – a product of better approach play and also better defending."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Shots Shot per conversion game Shot distance rate  % on target  % blocked  % wayward  % off target  1997  32.2  6.4%  32.1%  20.5%  7.6%  47.7%  2001  32.1  7.8%  33.3%  21.1%  6.2%  45.5%  2005  28.5  10.5%  34.3%  17.3%  8.3%  48.3%  2009  29.3  9.0%  35.1%  22.3%  7.9%  42.6%  2013  28.7  7.0%  29.7%  23.7%  8.9%  46.6%  2017  25.4  7.5%  31.3%  24.7%  9.0%  44.1%  2022  27.9  10.9%  33.3%  25.7%  6.8%  42.1%  THE TECHNICIAN  Shots under pressure  Shots under pressure 436 58%  484 60% 414 56%  267 50%  494 57%  Shot distance 18.8  19.1  18.5  186 47%  222 46%  18.4 17.5  17.2  1997  2001  2005  2009  2013  2017  2022  15.6  1997  2001  2005  2009  The average shot distance has fallen with every Women’s EURO since 2005 – at an average rate of 0.6m per tournament. In 2022, the average distance was 16.5 metres and this is  Shots attempted per match Shots attempted  32.3  32.6 28.7  30.9  30.5 26.9  27.9  Goalkeeper, saver percentage  1997  2001  2005  2009  2013  2017  2022  likely to be a consequence of teams seeking to create higher-quality goalscoring opportunities, which itself is a consequence, we can reasonably speculate, of better coaching.  Over 55% of shots are now taken under pressure – a slight dip from the 60% high recorded in 2017 but still a notable rise from the figure of just over 45% registered in 1997. Defensive organisation has improved over time, as already stated, and defenders are more aware of the need to disturb the player on the ball.  This wish to create scoring opportunities of a better standard has led, over the 25 years, to a drop in the number of shots attempted. From a high of 32.3 in 1997, the number has fallen steadily, with the lowest average figures having been recorded in the past two EUROs: 26.9 in 2017 and 27.9 this year. It is a downward trajectory that is expected to continue. At the same time, the shot conversion rate – which was 7.5% in the Netherlands in 2017 – has increased to a high of 10.9%. One reason for the increase could be an amelioration of players’  technique; another could be players making better decisions as to when to shoot. Both would be likely factors also for the reduced portion of shots that were off target – down to an all-time low of 42.1% this summer. It is worth considering too the percentage of blocked shots in this chart. This has slowly risen since 2005, with 25.7% the figure recorded at this year’s tournament. This supports the view that defensive organisation is improving over time, and the same can be said of the overall trend for more shots being taken under pressure.  2013  2017  Goalkeepers’ save percentage 80% 76% 73% 68%  71%  72%  65%  1997  2001  2005  2009  2013  2017  2022  Interestingly, while defences are now better organised, the save percentage of the goalkeepers at Women’s EUROs has fallen, from a high of 80% in 1997 to a low of 65% in 2022. Again this seems a likely product of the fact players are shooting from better positions.  2022  UEFA DIRECT • Q3 2022 – 31"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THE TECHNICIAN  AVERAGE NUMBER OF DEFENDERS WITHIN CONE Average number of defenders within cone  1.12  To expand this area of the analysis further, we should look at another measure of improved defensive positioning – the closer attention now given to players who are shooting at goal. In its study, StatsBomb used freeze frames on each shot to identify how many defenders are in place to potentially obstruct the shot each time. The resulting ‘defenders in cone’ metric involves the defensive players within view of the player shooting and the width of the goal. The more players there are between the shooter and the goal, the less space there is to place the shot. For the 2022 finals, the average number of defenders was 1.17 – the highest yet. For each of the first three tournaments in this analysis, the average was less than one defender, with 0.93 recorded in 2005; since 2009 it has been one or more, rising to this year’s figure.  0.97  1997  0.93  0.93  2001  2005  Attacker  2009  1.14  1.17  1.06  2013  2017  2022  Defender  SET PLAYS The study considered set pieces also and found that the balance between goals from open play (around 65%) and from set plays has been largely stable since the 2005 tournament in England.  Set Piece Shots per Game  Combined set-piece shots per game  8.5 8.3 8  1997  2001  7.8  2005  2009  32 – UEFA DIRECT • Q3 2022  2013  % from open play  % from corner  % from indirect free-kick  % from direct free-kick  % from penalty  % from throwins  1997  8.8  72.4%  12.8%  8.5%  4.1%  0.4%  1.9%  2001  7.71  75.5%  11.3  6.2%  4.6%  0.7%  1.8%  2005  8.43  69.9%  34.3%  10%  5%  0.7%  2.2%  2009  7.84  72.5%  35.1%  4.3%  3.8%  0.9%  0.7%  2013  7.96  71.6%  29.7%  6.2%  2.4%  0.8%  1.1%  2017  8.29  66.5%  31.3%  8.2%  4.9%  1.3%  1.9%  2022  9.1  72.5%  33.3%  4.8%  1.1%  1.1%  0.8%  9.1  8.8  7.7  Combined set-piece shots per game  2017  2022  The average combined number of shots per game from set pieces at this Women’s EURO was 9.1 – the highest yet. The fact that set pieces were more productive would indicate that teams have been focusing more on the detail and organisation of dead-ball situations, finding value in set plays as per the trend in the game generally. One additional point regarding set plays is that it would seem this extra attention to detail is focused on corner kicks. To refer to the chart below, at this year’s tournament, 20.6% of shots came from corners – the second-biggest source outside of open play (72.5%). There was a notable decrease in the percentage of goals from direct free-kicks – a drop of 3% since 2017 – but a 2% increase for indirect free-kicks."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THE TECHNICIAN  PRESSING – With purpose Pressure volume per team, per match Pressures 1997  134  2001  112  2005  154  2009  137  2013  117  2017  148  2022  152  Another area where the study offers food for thought is pressing. The average number of pressures per team per match in this year’s tournament was 152. Only in 2005 has a higher average been recorded (154) and, once more, it is fair to infer that rising fitness levels and improved coaching are both relevant causes.  Average duration of pressure events (seconds)  Average duration of pressure events (seconds) 0.93  0.92  0.97  0.98  2009  2013  1.05  1.03  2017  2022  0.8  1997  2001  2005  The duration of pressures is also noteworthy. This was above one second for the second tournament running – 1.03 compared with 1.05 in 2017 – and it supports the perception that teams are now better organised when it comes to pressing, with a specific plan for when to press and how long for. Pressure by pitch area As for the areas where teams press, the most pressing still occurs in their own half. However, there is an upward trend for pressing in the opposition half and middle third, and a downward trend for teams pressing in their own defensive third. In other words, as teams are looking to press higher, so they are winning the ball higher and therefore spending less time in low blocks.  Change in possession by zone The graphic underlines this tendency by displaying, tournament by tournament, the zones of the pitch where the most turnovers, or changes in possession, took place. Red signifies a high number of turnovers (completed tackles, interceptions and changes in possession forced by pressure events), while dark blue means few. While there was a steady increase in turnovers higher up the pitch prior to this year, the 2022 Women’s EURO witnessed a big change from previous tournaments, with a number of teams setting out in a high block – hence, for the first time, a prevalence of reds and pinks in the attacking third.  2013  1997  2001  2005  2009  2017  2022 UEFA DIRECT • Q3 2022 – 33"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THE TECHNICIAN  PASSING – Numbers up Number of teams by pass completion rate 6  5  4  3  2  1  0  1997  2001  50%  55%  2005  60%  65%  2009 70%  For another gauge of rising standards in the elite women’s game, the study provided an analysis of teams’ passing. The first point to make is that the pass completion percentages offer encouragement as, for the third tournament in a row, teams recorded  75%  2013  2017  2022  80%  percentages above 80%, with Spain leading the way. More and more teams are achieving a pass completion rate of 75%, which is regarded as the standard for those sides advancing to the knockout rounds. And evidence of greater consistency can also be found in the fact  the two best-represented categories in 2022 were 65% and 70%. In the 1997 tournament, the most popular category was 55% yet, by contrast, only once in the past four tournament has a side recorded a passing completion percentage below 60%.  Combined passes per game, by height 36%  14% 50%  1997 Ground passes  37%  31%  13%  14%  14%  14%  60%  55%  54%  2001  30%  31%  30%  31%  12%  8%  58%  61%  49%  2005 Low passes  34 – UEFA DIRECT • Q3 2022  High passes  2009  2013  2017  2022  The number of passes per game, meanwhile, has witnessed a steady climb. The 2022 tournament saw the highest average yet, with 942 per game and Spain leading the way with 619.2 passes per game. Regarding the table above, it should also be mentioned that the type of pass is evolving: in 1997 only 50% of passes were played on the ground and 14% were ‘low’ passes. By this year, 61% of passes were on the ground and just 8% were low."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THE TECHNICIAN  POSSESSION – A case of quality not quantity Possessions  Average time of possession  Average number of possessions per match 249  237  246.3  244.4  229.2 204.6  1997  2001  2005  2009  2013  2017  195.4  2022  For the first time, at this Women’s EURO the average number of possessions per match fell below 200. This marked the  of crosses per game has decreased across the last two tournaments, from a high of 24 in 2013 to 18 in 2022 (a 25% decrease in total). Although crossing remains the biggest source of goals, this is another sign of sides wanting to hold on to the ball in the final third and seek out the right pass or shooting chance, rather than rushing to put over a cross at the earliest opportunity.  continuation of a trend across the last five tournaments – a trend which has accelerated recently. From an average of 229.2 in 2013, there was a drop to 204.6 in 2017 and now to 195.4. This can be seen as another sign of the rise in the quality of general play. After all, fewer changes of possession would imply an improvement in the ability of teams to keep hold of the ball which, once again, corresponds with the notion that coaching levels have improved – along with individual skill – over the 25-year period in question. To remain on the subject of ball retention, the number  Average time of possession 11.9  11.6  12  12.5 11.4  10.9  10.1 1997  2001  2005  2009  2013  2017  2022  Finally, for the analysts working on this report, there was some surprise in the fact that the average time of possessions had fallen since 2013. To highlight this point, the average of 11 seconds this year was the lowest since 1997. To understand why, there is the suggestion that teams are slightly more direct in their attacking. Given the increase in technical ability, they can and do progress up the pitch more quickly – and with more passes – with the idea of creating as much disruption to the opposition as possible.  BALL IN PLAY – Time falls  DISCIPLINE  Average combined ball in play time  Percentage of fouls given red or yellow card  One final part of the study to reflect on concerns the amount of time the ball is in play. The bar chart shows a continuing slide in the average combined ball in play time, with Women’s EUR0 2022 registering the lowest average since the study began – just 53.9 minutes. This can be interpreted as a result of more competitive matches, featuring more contested play. Ball out of play time means stoppages for free-kicks, goalkicks, throw-ins and substitutions, and it could be argued that, owing to the greater competitive edge, teams are ‘managing’ the game in a more calculating way.  % of fouls given red or yellow card  13.4%  9.3% 8.1% 6.6%  5.7%  5.9%  4.8%  1997  2001  2005  2009  2013  2017  2022  This year’s tournament witnessed a 44% increase in the number of fouls for which players received a booking. One interpretation is that the speed of the elite women’s game has increased, which leads in turns to more fouls. Another is that improved technology has given referees more confidence to manage the game and make objective decisions. UEFA DIRECT • Q3 2022 – 35"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 36-title-1\" style=\"top:193px; left:57px;\" src=\"/199/en/static/_content/36-title-1.png\">\n        <img class=\"halfScale 36-sub-1\" style=\"top:570px; left:59px;\" src=\"/199/en/static/_content/36-sub-1.png\">\n      ",
    "script": "\n      \n      function onPageEnter() {\n        pg36Anim = new TimelineMax();\n        pg36Anim.fromTo(cOf(\"36-title-1\"), 0.6, {opacity:0, x:-30}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"36-sub-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg36Anim.stop();\n        removeContentLinks()\n      }\n      ",
    "searchText": "CLUB COMPETITIONS  THE ROADS TO ISTANBUL, BUDAPEST AND PRAGUE  Draw ceremonies in Istanbul launch the men’s club competitions.  D  ateline Istanbul. Thursday 25 and Friday 26 August. Calendars are not renowned for providing riveting reading. But, for once, dates were standout factors when the draws were made for the three major UEFA men’s club competitions at the Haliç Congress Center. With the World Cup looming large in its novel time slot, the group stages of all three needed to be compressed into an unusually short space of time – to the extent that, between print deadlines and publication date, groups will have already begun to take shape before these words appear. The venues for the three club competition finals to be played in 2023 are evocative. Not least the Atatürk Olympic Stadium. Liverpool supporters might fancy being there on Saturday 36 – UEFA DIRECT • Q3 2022  10 June – especially those who were there for the final in 2005 that was arguably one of the most remarkable of the 30 finals played since the UEFA Champions League was introduced. Rafa Benítez’s team, 3-0 down at half-time against Carlo Ancelotti’s AC Milan, produced a miraculous second-half comeback to draw 3-3 and lift the trophy after winning 3-2 in the penalty shoot-out. AC Milan supporters (and Carlo Ancelotti) might welcome a return visit 18 seasons later to exorcise a few ghosts. The Champions League draw in Istanbul at least kept the two clubs apart in the group stage, with both going into quartets featuring two former champions of Europe: Liverpool joining AFC Ajax and AC Milan facing Chelsea FC. But, as always, the draw provided a cue to bring out the ‘group of death’ clichés.  To be precise, Group C was the one to provoke gasping in the congress centre. The presence of FC Bayern München, FC Barcelona and FC Internazionale Milano alongside FC Viktoria Plzen means that by the time the groups have been completed, unusually early, in the first week of November, at least one former champion of Europe will have been eliminated from the race back to Istanbul. By contrast, three groups contain only one previous winner, while the other four contain two. Anecdotally, the draw in Istanbul featured five of the eight clubs that entered the group phase of the inaugural UEFA Champions League 30 years ago, but not the ones you might think. In the autumn of 1992, Olympique Marseille, Club Brugge and Rangers FC played in Group A, while AC Milan and FC Porto"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "CLUB COMPETITIONS  were in the other quartet, alongside IFK Göteborg and PSV Eindhoven. On the following day at the Haliç Congress Center, four ex-champs of Europe (FK Crvena Zvezda, Feyenoord, Manchester United and the aforementioned PSV Eindhoven) went into the pots as the draw for the UEFA Europa League fired the starting pistol for the race towards the Puskás Arena in Budapest, where the final on Wednesday 31 will be the only one to squeeze into the month of May 2023. Inaugurated in 2019, it was the venue for the UEFA Super Cup in the following year, when FC Bayern München defeated Sevilla FC 2-1. They could meet there again. But that possibility needs to be spoken in a whisper as neither club – even though the Spanish team reigns supreme in this competition with six  victories – would even wish to contemplate diversion from the UEFA Champions League when the group stage concludes in November. The hat-trick was completed by the draw for the group stage of the UEFA Europa Conference League, where the dream is about trotting on to the pitch in Prague on Wednesday 7 June 2023. The Eden Arena is home to Slavia Praha, who would dearly love to entertain visitors for the final. The Czech club came out of the hat in Group G alongside CFR Cluj, Sivasspor and Ballkani, who have just made history as the first club from Kosovo to make it through to the group stage of a UEFA club competition. The Eden Arena, by the way, has hosted two previous finals – and both went through extra-time into penalty shoot-outs.  In the 2013 UEFA Super Cup, FC Bayern München, whose name keeps cropping up, won 5-4 after a 2-2 draw with Chelsea. And, in the final of the European Under-21 Championship in 2015, Sweden prevailed 4-3 after a goalless draw, featuring seven goal attempts in two hours, against a Portugal side containing the current Manchester City duo of Bernardo Silva and João Cancelo. The final in Prague will be the penultimate in a busy sequence where the final of the UEFA Women’s Champions League is scheduled for the first weekend in June and, as usual, the men’s equivalent competition will bring the club competition season to its climax a week later. But a lot of football needs to be played before the identities of the four champions are revealed. UEFA DIRECT • Q3 2022 – 37"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 38-title-1\" style=\"top:131px; left:57px;\" src=\"/199/en/static/_content/38-title-1.png\">\n        <img class=\"halfScale 38-sub-1\" style=\"top:671px; left:59px;\" src=\"/199/en/static/_content/38-sub-1.png\">\n      ",
    "script": "\n      \n      function onPageEnter() {\n        pg38Anim = new TimelineMax();\n        pg38Anim.fromTo(cOf(\"38-title-1\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"38-sub-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg38Anim.stop();\n        removeContentLinks()\n      }\n      ",
    "searchText": "CLUB COMPETITIONS  2022 UEFA AWARDS  UEFA president Aleksander Čeferin with Arrigo Sacchi, Alexia Putellas, Karim Benzema and Carlo Ancelotti.  Benzema and Putellas take the UEFA Player of the Year awards, with the ceremony in Istanbul also honouring two Italian coaches.  W  hen Karim Benzema first caught the eye as a 16-year-old member of the France team that won the European Under-17 Championship in 2004, not even he could have imagined that the season of his life would materialise 18 years later and earn him a centre-stage appearance at the Haliç Congress Center in Istanbul to collect the UEFA Men’s Player of the Year award. 38 – UEFA DIRECT • Q3 2022  To argue with that, fans in his home city of Lyon might put up, as a rival contender, 2007/08 when he totted up his fourth Ligue 1 title with Olympique Lyonnais, and picked up Ligue 1 top scorer and player of the year awards. But, at 20, he had yet to acquire the tactical maturity, positional wisdom and finishing expertise that he was to display in the Real Madrid shirt 14 years later and would allow him to  win the award by such an enormous distance that he more than quadrupled the voting points accumulated by his nearest pursuers – the Belgian duo of Manchester City’s Kevin De Bruyne and his Real Madrid team-mate Thibaut Courtois. Statistics spoke highly of his merits. By a massive margin, Benzema was top scorer in La Liga, his tally of 27"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 39-quote-1\" style=\"top:152px; left:459px;\" src=\"/199/en/static/_content/39-quote-1.png\">\n      ",
    "script": "\n      \n      function onPageEnter() {\n        pg39Anim = new TimelineMax();\n        pg39Anim.fromTo(cOf(\"39-quote-1\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n      }\n\n      function onPageLeave() {\n        pg39Anim.stop();\n        removeContentLinks()\n      }\n      ",
    "searchText": "CLUB COMPETITIONS  representing one third of Real Madrid’s goals. And another 15 – more than half of the side’s UEFA Champions League total – included a sequence of crucial goals in the knockout ties when his team was teetering on the brink of elimination. In Istanbul, he picked out his hat-trick against Paris Saint-Germain as the most abiding memory of his campaign, along with Carlo Ancelotti’s ability to reduce pressure on the players and impart a mood of calm confidence – which provides a cue to step from playing to coaching for a moment to pay tribute to the Italian who was on stage to receive the UEFA Men’s Coach of the Year award. Typically, he shied away from protagonism. “Individual awards are really about what the team has achieved,” he insisted in Istanbul. “So the award is something to share with everyone who made it possible.” He makes no secret of his conviction that empathy and the ability to create positive environments and relationships are an important element in the coach’s repertoire – a view shared by his nearest pursuers in the voting, Jürgen Klopp and Josep Guardiola.  Still with coaches, another Italian maestro was the recipient of the UEFA President’s Award in recognition of, as Aleksander Čeferin put it, “his endless tactical innovations”. “Arrigo Sacchi reinvented the ethos of teamwork, which transcended to pure harmony on the pitch,” the UEFA president added. “Perfect synchronisation and a winning mindset, irrespective of whether they were playing at home or away.” Selfdeprecatingly, the legendary AC Milan coach maintained that his ideas were simple. But making football look simple requires hard work and genius… To complete the hat-trick of awards for coaches, Sarina Wiegman broke new ground en route to the UEFA Women’s Coach of the Year award. By lifting the Women’s EURO 2022 trophy with England in July, she became the first coach to win successive EUROs with two different countries, both of which were host nations and victorious for the first time in the competition’s history. The final at Wembley climaxed a season in which Wiegman’s team remained unbeaten and ran up a goal tally of 106 scored and five conceded.  After leading the Netherlands to Women’s EURO victory in 2017, followed by England in 2022, Sarina Wiegman was named UEFA Women’s Coach of the Year for 2021/22.  “With his endless tactical innovations, Arrigo Sacchi reinvented the ethos of teamwork, which transcended to pure harmony on the pitch.”s, Aleksander Čeferin UEFA President  More significantly, maybe, she became the first female coach to earn the award, taking the baton from two male club coaches, Lluís Cortés of FC Barcelona and Jean-Luc Vasseur of Olympique Lyonnais. And two female colleagues followed Wiegman in the voting: Sonia Bompastor, UEFA Women’s Champions League winner with Olympique Lyonnais, and Martina Voss-Tecklenburg, silvermedallist with Germany at Women’s EURO 2022. Now back to players – and to FC Barcelona’s and Spain’s attacking midfielder Alexia Putellas, winner of the UEFA Women’s Player of the Year award for the second successive season, this time ahead of England right-winger Beth Mead and Germany’s 20-year-old controlling midfielder Lena Oberdorf, voted Young Player of the Tournament by UEFA’s technical observers at Women’s EURO 2022. Top scorer in the UEFA Women’s Champions League with 11 goals and the supplier of 18 goals and 16 assists in Barça’s title-winning league campaign, Putellas had scored eight in a dozen games with the national team – taking her past 100 appearances – before being cruelly ruled out of Women’s EURO 2022 by a cruciate ligament injury. On stage in Istanbul she confessed: “I want to get back to playing and training and to be able to do my job, which is what I like doing most.” Football lovers all over Europe cannot wait to see her back in action again. UEFA DIRECT • Q3 2022 – 39"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 40-title-1\" style=\"top:494px; left:59px;\" src=\"/199/en/static/_content/40-title-1.png\">\n        <img class=\"halfScale 40-sub-1\" style=\"top:612px; left:59px;\" src=\"/199/en/static/_content/40-sub-1.png\">\n\n        <a href=\"https://www.uefa.tv/video/vod/382145/\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:475px;left:513px;\" src=\"/199/en/static/_content/40-play-1.png\">\n        </a>\n      ",
    "script": "\n      \n      function onPageEnter() {\n        pg40Anim = new TimelineMax();\n        pg40Anim.fromTo(cOf(\"40-title-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"40-sub-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg40Anim.stop();\n        removeContentLinks()\n      }\n      ",
    "searchText": "SPREADING HAPPINESS IN HELSINKI  The whole match  Young footballers with cerebral palsy enjoyed a Super Cup experience to remember thanks to the UEFA Foundation for Children.  T  he UEFA Super Cup has long been regarded as a special occasion, bringing together the previous season’s UEFA Champions League and UEFA Europa League winners to celebrate the new campaign, but the event is about much more than what happens during the 90 minutes. It also provides an annual opportunity for the UEFA Foundation for Children to support inspirational local projects, and Helsinki 2022 was no different. Since 2015, the foundation has helped more than one million children all over the world, and in Finland it teamed up 40 – UEFA DIRECT • Q3 2022  with two charities – Cerebral Palsy Football (CPF) and Icehearts – to create some lifelong memories for disadvantaged young people. The day before Real Madrid met Eintracht Frankfurt at the city’s Olympic Stadium, 16 children joined specially trained cerebral palsy (CP) football coaches at the Bolt Arena, home to HJK Helsinki, where the club’s women’s squad and men’s stars Paulus Arajuuri, Santeri Väänänen and Miro Tenho were waiting to take part in a unique training session, culminating in one huge match featuring fantastic action, goals galore and smiles aplenty.  “Events like today are important to show there are people like me that have cerebral palsy, which sometimes makes it harder to move physically,” said 13-year-old Maisa Fraser. “One thing I love about playing football is the friendship and the team – the team is like a second family, you have to appreciate every single one of them.It’s a life lesson – you have to appreciate everyone in your life.” Midfielder Essi Sainio was part of Finland’s Women’s EURO 2022 squad and took time to talk with the youngsters and pose for selfies at the end of the session. “Everybody should have the"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SUPER CUP  Karim Benzema, the architect of Real Madrid’s Champions League and Super Cup victories.  Finland’s time to shine Helsinki became the tenth city in ten years to stage the UEFA Super Cup, August’s event marking the first major UEFA club final hosted by the Finnish FA. UEFA’s decision to rotate the venue for the season kick-off showpiece has proved a popular move with clubs and fans alike. It also provides an important stage for more national associations to showcase their stadiums and event expertise, offering an important opportunity to attract fans to the game and contribute to the game’s ongoing development. “It’s a big thing for us to promote our capital, Helsinki, as well as football generally in Finland,” said Finland’s men’s team coach, Markku Kanerva. “Seeing these teams live is fantastic for the fans. “It’s a great thing because in the past, we didn’t have so many big football events like we have had in other sports. That’s very good for football. In Helsinki, there are so many players, girls and boys, there are still not enough pitches in the winter, but this situation has improved a lot, and coach education is vitally important and has also improved greatly – it’s something that we have really focused on in the association.”  10 AUGUST 2022 – HELSINKI Real Madrid CF 2-0 Eintracht Frankfurt  chance to play football and be themselves,” she said. “It is amazing to see the joy in the kids and see how much they enjoy playing football – you cannot name a price for that. Football is a language we can all talk – it doesn’t matter where you come from or who you are.” CP football coach Ville Sallinen wants to attract more young players to a game that has more than 80 groups and clubs across Finland, and believes events like this can spread an important message. “Diversity is important, it’s valuable and it should be cherished,” he said. “Everyone should have equal opportunities to enjoy the game that so many people love around the world. The kids were all very excited, honoured and a little bit nervous in a good way!”  Sallinen’s work comes under the Football Association of Finland’s grassroots programme, which has 25 years’ experience in organising disability football. Its grassroots expert Lasse Keski-Loppi was delighted they could demonstrate their fantastic work to a wider audience. “We are proud to showcase our grassroots programme at the Super Cup,” he said. “This year we launched our own CP football programme to promote football for all in Finland. This helps many new young players to participate in football and follow their dreams. We all share the same game.” Four of the children were also specially selected to become player escorts at the Super Cup match, rubbing shoulders with their Champions League and Europa League heroes, while behind  them 20 youngsters from the Icehearts association performed as centre-circle carriers during the pre-match ceremony on the pristine Olympic Stadium pitch. Icehearts provides long-term support for vulnerable children through sport, offering mentoring and playing opportunities to those who, for whatever reason, would not otherwise be able to participate. “When selecting the children participating in the Super Cup, we wanted to reward those who have shown special effort in their studies and share a true passion for football,” said Icehearts’ Karo Koivunen. “They are excited to be part of this magical moment – football is their life!” It is these magical moments that make the work of the UEFA foundation and its partners so valuable, not just once a year but all year round. UEFA DIRECT • Q3 2022 – 41"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 42-title-1\" style=\"top:153px; left:59px;\" src=\"/199/en/static/_content/42-title-1.png\">\n        <img class=\"halfScale 42-sub-1\" style=\"top:582px; left:59px;\" src=\"/199/en/static/_content/42-sub-1.png\">\n\n        <a href=\"https://www.uefa.tv/competition/U-19\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:563px;left:462px;\" src=\"/199/en/static/_content/42-play-1.png\">\n        </a>\n\n        <div class=\"addContentLink\" style=\"top:594px;left:536px;width:39px;height:16px;\">\n          <a href=\"/199/en/static/_content/results-U19.pdf\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n      \n      function onPageEnter() {\n        pg42Anim = new TimelineMax();\n        pg42Anim.fromTo(cOf(\"42-title-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"42-sub-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg42Anim.stop();\n        removeContentLinks()\n      }\n      ",
    "searchText": "A NEW TITLE FOR ENGLAND  From 18 June to 1 July, Slovakia was the setting for the first European Under-19 Championship finals in three years, a 14-day tournament that ended with England victorious.  I  an Foster’s team won all five of their matches, though they had to dig deep in the final on 1 July against an impressive Israel side, coming from behind to prevail 3-1 after extra time through goals from Callum Doyle, Carney Chukwuemeka and Aaron Ramsey. For England, this was their second men’s title in this age category following their 2017 triumph in Georgia. For Israel, there was reason to celebrate too: never before had one of their teams reached the final of a UEFA national team competition and their feats rewarded the forward-looking work of the Israel Football Association (IFA) under technical director Jelle Goes,  42 – UEFA DIRECT • Q3 2022  which had included improved cooperation with their clubs to provide coach Ofir Haim with weekly access to his national Under-19 squad on the training pitch. Israel’s reward is a first ticket to the U-20 World Cup. England and semifinalists France and Italy will also represent UEFA at next year’s tournament in Singapore – and so too Slovakia, after the host nation defeated Austria 1-0 in a play-off for fifth place. Overall, the Under-19 finals drew an aggregate attendance of 38,000 and those spectators saw some bright young talents, including France forward Loum Tchaouna, who finished as the tournament’s  Oscar Gloukh capped a blistering counterattack to fire past England goalkeeper Matthew Cox and give Israel the lead five minutes before half-time.  Results  four-goal top scorer, and Israel No10 Oscar Gloukh, who earned the Goal of the Tournament prize for an outstanding strike in the final. Cast list Owing to the pandemic, this was the first men’s Under-19 final tournament since the 2019 edition in Armenia. The cast list included four previous winners – France, Italy, England and Serbia – along with two countries competing for only the second time, Israel and Romania. The qualifying process had begun in autumn 2021 with an initial round comprising 13 four-team mini-"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "EUROPEAN UNDER-19 CHAMPIONSHIP  tournaments. It continued in the spring with an elite round in which the 28 surviving sides split into seven groups of four – albeit Russia’s enforced withdrawal reduced one of the groups to three. That particular group contained holders Spain but, on home turf, they gave up two-goal leads in successive draws with both Austria and Denmark, and Austria duly advanced. Another high-profile casualty were Portugal, who had received a bye to the elite round as the team with the highest seeding coefficient yet fell there at the hands of England. Serbia were the last qualifiers, winning by the narrowest of margins their delayed elite round group in the Netherlands at the start of June. Only their better disciplinary record separated them from Ukraine – 10 yellow cards to their rivals’ 13. So to the final tournament, staged across five venues, starting at the 18,100-capacity Trnava Stadium, which hosted five matches, including France’s 5-0 opening-day crushing of Slovakia and the final. France, who equalled Spain’s record of most finals appearances (12), were Group A’s dominant force, hitting 11 goals as they supplemented that victory over Slovakia with wins over Romania and second-placed Italy. While the Group A action unfolded in western Slovakia – in Trnava and Dunajská Streda – Group B was played out in the  central venues of Banská Bystrica and Žiar Nad Hronom, and there it was England who excelled. They won all three games without conceding a goal, including a 1-0 victory over the Israel side who would join them in the last four by following up a 2-2 draw with Serbia with a 4-2 success against Austria. Israel then produced the big story on semi-final day, 28 June, by defeating France 2-1 in Dunajská Streda. After Isaak Touré’s first-half own goal, midfielder El Yam Kancepolsky doubled Israel’s lead with a header from a corner and although Alan Virginius struck a goal back, France’s 20 attempts yielded nothing more. “We’ve made history,” said the jubilant Israel coach Haim. Their final opponents would be England, who came back to defeat Italy 2-1 at the NTC Senec. After Fabio Miretti’s early spot kick, Foster’s side responded with two second-half headers from corners by Alex Scott and Jarell Quansah. The final, three days later, began with Israel producing “the best football this team has ever played”, to quote coach Haim. A superb first-half display was capped with Gloukh’s brilliant goal: after instigating a break from inside his own half, he was in place to receive the ball from Ariel Lugassy on the edge of the box, cut inside Ronnie Edwards and then outside Doyle before flashing a shot past goalkeeper Matthew Cox.  28 JUNE U-20 World Cup play-off Slovakia 1-0 Austria Semi-finals France 1-2 England 2-1  Israel Italy  1 JULY Final Israel  1-3  England, aet  “The only positive from the first half is that it was only one,” admitted England coach Foster, yet his team were “more aggressive” thereafter in closing down Israel’s talented midfielders. Doyle equalised with a near-post finish following a corner after 52 minutes. Then, in the second period of extra time, Chukwuemeka bundled Harvey Vale’s deep cross over the line before Ramsey buried the rebound after a break and shot by fellow substitute Liam Delap. England’s superior strength in depth had told."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 44-title-1\" style=\"top:131px; left:59px;\" src=\"/199/en/static/_content/44-title-1.png\">\n        <img class=\"halfScale 44-sub-1\" style=\"top:211px; left:59px;\" src=\"/199/en/static/_content/44-sub-1.png\">\n\n        <a href=\"https://www.uefa.tv/competition/WU-19\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:41px;left:233px;\" src=\"/199/en/static/_content/44-play-1.png\">\n        </a>\n\n        <div class=\"addContentLink\" style=\"top:72px;left:307px;width:39px;height:16px;\">\n          <a href=\"/199/en/static/_content/results-wu19.pdf\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n      \n      function onPageEnter() {\n        pg44Anim = new TimelineMax();\n        pg44Anim.fromTo(cOf(\"44-title-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"44-sub-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg44Anim.stop();\n        removeContentLinks()\n      }\n      ",
    "searchText": "Results  SPAIN COLLECT NEW TITLE IN CZECH REPUBLIC Spain obtained their third European Women’s Under-19 title in four tournaments with success in the Czech Republic between 27 June and 9 July.  V  ictory for Pedro Lopez’s side, their fourth title at this level overall, came after a closely contested final with Norway at Ostrava’s Metsky Stadium on 9 July. After falling behind to a well-taken goal by Norway’s Iris Omarsdottir on five minutes, Spain fought back to level through Ane Elexpuru after 36 minutes. A tight second half followed with Spain having to work hard to break down a determined Norwegian defence. Hege Riise’s side successfully repelled Spain’s attack until added time, when FC Barcelona’s Julia Bartel found the breakthrough with the decisive strike in the 94th minute.  “I think we did everything possible to win the final,” Lopez said after the final whistle. “We tried absolutely everything, and I think the squad are fully deserving of the victory. We knew extra time was a possibility, but we were creating chances. Norway didn’t have too many chances and we had hope that the goal would come.” It was much-deserved success for Lopez’s side, who impressed throughout the two-week tournament with their tactical versatility and individual skill. Victories over Italy and the Czech Republic and a 1-1 draw with France meant an unbeaten run to the top of Group A. Another impressive display saw Sweden dispatched 1-0 in the semi-final.  López praised the togetherness of the squad both on and off the pitch and the journey the team had been on together: “I really like the work this team has put in,” he said. “The development they have had right through the whole season. They have shown great unity on and off the pitch.” That unity was extended to the senior women’s team and the unfortunate injury suffered by Alexia Putellas, the senior team’s captain, that saw her ruled out of the UEFA Women’s EURO. As the Under-19 squad celebrated with the EURO trophy, the No14 shirt of Putellas was displayed. After the disappointment of defeat in the final softened, Norway, too, could look  Spain’s Under-19s hold up a No14 shirt in a show of unity with their women’s team captain, Alexia Putellas, ruled out of Women’s EURO 2022 because of injury.  44 – UEFA DIRECT • Q3 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "back on a commendable campaign. After losing their opening group game 4-1 to England, Riise’s side recovered to beat both Germany and Sweden in Group B. Another impressive victory followed in the 1-0 semi-final victory over France. “We were so close to going into extra time,” Riise said after the final. “We cannot play like Spain. We need to be strong in defence and good on the counterattack, and that’s what we did. The girls should be proud of their performance. “Of course, they’re disappointed now, but they will learn so much from going through the group stage and knockout stage. “The early goal was exactly in our thinking of how we could do it. We followed the game plan well, being strong and not letting Spain get into space. The games we won against Sweden and France, it went our way. This time, it was the opposite. We were close, but not close enough.”  Valtr also believes hosting the tournament will help the Czech FA achieve its strategic targets for growing women’s football in the future. “Our association has set an ambitious goal of reaching 25,000 registered players by 2024. We are confident that events such as the Women’s Under-19 EURO will help attract interest in women’s football and bring new players into our ranks. Examples of successful careers of female players also play a big role, as more than half of the national team plays in quality clubs abroad.” For the Czech Republic, the European Women’s Under-19 Championship was the latest in a number of recent tournament appointments, including the 2013 UEFA Super Cup, 2015 European Under-21 Championship and 2017 European Women’s Under-17 Championship, with the UEFA Europa Conference League final to be held in Prague next May.  6 JULY Semi-finals Spain 1-0 Norway 1-0  Sweden France  9 JULY Final Spain  2-1  Norway  Helping women’s football to grow in the Czech Republic Although the host side, the Czech Republic, failed to qualify from Group A, where they faced the formidable task of playing against Spain, Italy and France, Jan Navratil’s side acquitted themselves well against tough opposition. The host nation played with spirit and commitment until the final minute of their last group game against Italy and were unfortunate not to upset one of the big European nations. The general secretary of the Football Association of the Czech Republic, Michal Valtr, believes the opportunity for the Czech Under-19 team to compete with high-quality opposition will be of benefit for the development of the women’s game in the country in the future. “For us, as the organisers of the final tournament, it brings one extra bonus – our national team could compete in the qualifiers and, regardless of the results, were guaranteed to participate in the final tournament. The opportunity to play quality matches will definitely help the development of our best players in the Under-19 category.”  Norway’s Selma Løvås up against Spain’s Andrea Medina.  UEFA DIRECT • Q3 2022 – 45"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 46-title-1\" style=\"top:131px; left:59px;\" src=\"/199/en/static/_content/46-title-1.png\">\n        <img class=\"halfScale 46-sub-1\" style=\"top:213px; left:59px;\" src=\"/199/en/static/_content/46-sub-1.png\">\n\n        <a href=\"https://www.uefa.tv/competition/WU-19\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:276px;left:39px;\" src=\"/199/en/static/_content/46-play-1.png\">\n        </a>\n\n        <div class=\"addContentLink\" style=\"top:307px;left:112px;width:39px;height:16px;\">\n          <a href=\"/199/en/static/_content/results-womens-futsal-euro.pdf\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n      \n      function onPageEnter() {\n        pg46Anim = new TimelineMax();\n        pg46Anim.fromTo(cOf(\"46-title-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"46-sub-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg46Anim.stop();\n        removeContentLinks()\n      }\n      ",
    "searchText": "EURO TITLE NUMBER TWO FOR SPAIN Spain’s Women’s Futsal EURO victory to act as a platform for further growth and development of the game.  Results  A  s Spain celebrated the 4-1 penalty shoot-out victory over Portugal that crowned them champions of Women’s Futsal EURO 2022, their goalkeeper, Silvia Aguete – who made two crucial saves during the shoot-out – used the moment to call for further growth of women’s futsal. “It’s really important for the sport to have these kinds of matches with this atmosphere,” Aguete said at the final whistle of a thrilling tie that finished 3-3 after extra time and was watched by a capacity crowd. “Everybody needs to keep working so we can improve women’s futsal even more,” she added. Ahead of the tournament, Aguete recalled her early experiences as a female futsal player, describing the difficulty she faced in gaining the recognition she and others deserved: “I remember my first licence: it read ‘amateur player’, despite me training every day for years,” she said. “Now teams are becoming more and more professional – we are on a good track. I could never imagine that a Women’s Futsal EURO would ever be created, so it is a dream taking part in it.” Progress and development were clearly evident during the four-team final tournament, contested by Spain, Portugal, Ukraine and Hungary (in replacement of Russia) between 1 and 3 July in Gondomar, Portugal. [The final tournament – originally scheduled to run from 25 to 27 March 2022 – had been postponed after consultation and with the agreement of the host association.] With both highquality action on the court and impressive crowds and excitement in the stands, the finals were a symbol of the game’s growth. Now, Aguete wants everyone involved in women’s futsal to build on the momentum of the tournament success. “Women’s futsal has been working for a long time to have a European cup, to get people moving, to get the fans moving and for things to take effect,” she said. “I think it’s important that we’re given visibility and that we carry it forward. Let’s continue like that.” Before the announcement of the first Women’s Futsal EURO tournament in 2017, there were only seven national teams in  The first two editions of the Women’s Futsal EURO have both been played in Portugal and both been won by Spain against the hosts."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "1 JULY Semi-finals Ukraine 0-9 Portugal 6-0  Spain Hungary  3 JULY Third-place play-off Hungary 1-2 Ukraine Final Portugal  3-3 Spain (aet), 1-4 (pens)  Fifo and her Portuguese team-mates kept the pressure on Spain and took the final to a penalty shoot-out.  Europe. In the years since the inaugural tournament, that number has close to quadrupled. The aim is to reach 30 teams for the fourth edition in 2024/25. Spain retain title on penalties After winning the first-ever Women’s Futsal EURO in 2019, also against Portugal, Spain returned to the scene of their success to add EURO title number two to their collection in 2022. In the inaugural  final three years ago, Spain ran out 4-0 winners. On that occasion, goals from Mayte, Ana Luján and Amelia Romero saw them take a 3-0 lead within ten minutes. This time round, however, the narrative of the contest was considerably different. Within 18 minutes, goals from Portugal’s Ana Azevedo and Pisko meant the hosts found themselves with a 2-0 lead over the holders. Spain were, however, quick to respond and Ale de Paz’s double strike forced the game into extra time. It was here that Spain went ahead in the tie for first time, Sanz scoring after 43 minutes. However, five minutes later, Portugal’s Pisko went on to add her second of the game to send the contest to penalties. From there, Spain’s composure and the goalkeeping skills of Aguete ensured victory in a thrilling and closely contested tie. While celebrating victory, Spain’s goalscorer Ale de Paz praised the effort of her team-mates and the support of the national association for their success: “The only secret behind Spain’s success is the hard work done by the players, the clubs and the national association,”  After finishing fourth in 2019, Ukraine did one better this time round, pipping Hungary to third place.  she said. “It was truly special to play in a match like this one, because it was the final and the atmosphere was simply unbelievable. This is Spain’s second title and my first. I’m living a dream.” Ale de Paz went on to describe the excitement experienced during the final as well as acknowledging Portugal’s contribution to an absorbing contest: “It was an amazing match by both teams and I think you couldn’t ask for a better or more dramatic final. It’s amazing to be holding this trophy and it’s hard to describe what it means. I’m very happy to have scored two goals but even more because that helped my team to achieve their final objective.” Although disappointed with the result, Portugal’s Inês Fernandes thanked the incredible support of a sold-out arena in Gondomar: “I feel really sorry for our amazing fans because they deserved a different result,” she said. “I want to thank everyone who was here tonight and at home supporting us. We felt their strength.” Spain had booked their place in the final after a convincing 9-0 victory over Ukraine in the semi-finals. Portugal enjoyed a similarly emphatic win on the way to the final, beating Hungary 6-0. In the third-place play-off, Ukraine overcame Hungary 2-1 to finish third in the competition. UEFA DIRECT • Q3 2022 – 47"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 48-title-1\" style=\"top:131px; left:59px;\" src=\"/199/en/static/_content/48-title-1.png\">\n        <img class=\"halfScale 48-sub-1\" style=\"top:218px; left:59px;\" src=\"/199/en/static/_content/48-sub-1.png\">\n\n        <a href=\"https://www.uefa.tv/competition/EUROQ\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:54px;left:39px;\" src=\"/199/en/static/_content/48-play-1.png\">\n        </a>\n      ",
    "script": "\n      \n      function onPageEnter() {\n        pg48Anim = new TimelineMax();\n        pg48Anim.fromTo(cOf(\"48-title-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"48-sub-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg48Anim.stop();\n        removeContentLinks()\n      }\n      ",
    "searchText": "WORLD CUP 2022  OUT TO CONQUER THE WORLD! Having lifted the trophy in 2006 (Italy), 2010 (Spain), 2014 (Germany) and 2018 (France), European nations are hoping to make it five in a row by winning the 2022 FIFA World Cup.  T  hirteen European countries booked their tickets for Qatar in a qualifying tournament in which standards were impressively high. Even though the reigning European champions, Italy, will be missing (as they were in 2018), there are many familiar faces among the contenders for the world title. Of the continent’s 13 representatives in Qatar, only the Netherlands and Wales were absent in Russia in 2018, when the European teams produced some outstanding results (ten reached the round of 16, six the quarter-finals and four the semi-finals). The last nonEuropean victory came in 2002, when Brazil won the first World Cup to be held on Asian soil, in South Korea and Japan. Which of them is in the best position to win this year’s World Cup? UEFA Direct runs the rule over the 13 teams vying to bring the trophy back to European soil again. Group A: The Netherlands are back! Surprise absentees at EURO 2016 and the 2018 World Cup, the Netherlands are quietly making their way back to centre stage, with recent results demonstrating clear signs of progress. At EURO 2020, the Dutch were knocked out in the round of 16 after some encouraging group stage performances. They then sealed their place in Qatar after a solid campaign in which Memphis Depay played a crucial role, finishing as the qualifying competition’s joint leading scorer with 12 goals and joint leader of the assists table with six. With three wins and a draw in their opening four matches, the Netherlands have also made an excellent start in the 2022/23 UEFA Nations League. Frenkie de Jong and his team-mates are favourites to win a World Cup group that includes their  48 – UEFA DIRECT • Q3 2022  Qatari hosts, Senegal and Ecuador, and will be hoping to follow in the footsteps of the great Dutch sides of the past, who were runners-up in 1974, 1978 and 2010. They will be guided by the experienced and indefatigable Louis van Gaal, now in his third spell as the Oranje coach, who led the Netherlands to the semi-finals in 2014. Group B: England crave success while Wales make long-awaited return For two British neighbours, expectations could hardly more different. On one side of the border, since Gareth Southgate’s appointment as coach England have been steadily establishing themselves as a powerhouse of world football. Semifinalists at the 2018 World Cup, at EURO 2020 the English looked set to lift their first major trophy since 1966, but saw Italy snatch the European title on penalties in front of a stunned Wembley crowd. Rather than lose heart, the unstoppable Harry Kane (joint top scorer with 12 goals) and his team-mates flew through the qualifiers, finishing with the most goals scored (39) and the best goal difference (+36). The England backroom staff’s meticulous preparation for final tournaments will once again put the team in good stead to lift the biggest prize of all. Before they look too far ahead, however, the English will need to find their way out of a group that also includes the United States, Iran and Wales. The draw gave the Welsh genuine hope of reaching the round of 16 as they return to the World Cup stage 64 years after their only previous appearance, when they reached the 1958 quarter-finals. Despite failing to keep pace with Belgium in their qualifying group, Wales took advantage of a frenzied atmosphere  Absent from the 2018 World Cup, the Netherlands return to the finals this year, as do Wales, for whom it will be the first finals since 1958."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "WORLD CUP 2022  at Cardiff City Stadium to beat Austria and Ukraine in the play-offs, with Gareth Bale once again their saviour. Although they were knocked out in the EURO 2020 round of 16, the Dragons proved that they are more than capable of holding their own in major tournaments by reaching the EURO 2016 semi-finals.  Semi-finalists four years ago, England will be out to go even further in Qatar, as will Poland, who last reached the semi-finals in 1982.  Group C: Poles aiming to break the curse Eliminated in the first round in each of their last three World Cup appearances (2002, 2006 and 2018), Poland will fancy themselves to emerge from a group in which they will face Argentina, Mexico and Saudi Arabia. Robert Lewandowski, who holds the record for appearances  (130) and goals (75) for the Polish men’s national team but has yet to shine at a major tournament, will be desperate to lead his team into the round of 16 for the first time since 1986. Reaching the knockout stages was considered a formality for Poland in those days, following semi-final appearances in 1974 and 1982, but that is certainly not the case this year. After finishing runnersup to England in their qualifying group, the Poles got the better of Sweden in their play-off final, gaining revenge over the Swedes, who had thwarted their efforts to progress from the EURO 2020 group stage a few months earlier. Group D: France and Denmark, a winning reunion? It is hard not to draw parallels with the 2018 World Cup. Just like four years ago, France and Denmark find themselves in the same group. Their goalless draw in 2018 did not live long in the memory, in stark contrast to the French team’s subsequent run to a second World Cup title after their first in 1998, when Les Bleus also faced Denmark in the group stage. Since lifting the trophy in 2018, Didier Deschamps’ men have blown hot and cold, losing in the EURO 2020 round of 16 before a superb victory in the 2021 Nations League finals. With the Mbappé– Benzema partnership up front, France have enormous attacking potential, but the defensive solidity that was such a strength in 2018 has recently given way to a certain vulnerability at the back.  Just like four years ago, France – who went on to win the 2018 World Cup – and Denmark are starting out in the same group.  UEFA DIRECT • Q3 2022 – 49"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "WORLD CUP 2022  Denmark took advantage of the shaky French defence in a recent 2-1 Nations League win at the Stade de France, less than six months before the countries meet again in Qatar. Their victory backed up an impressive recent run of results by Kasper Hjulmand’s team, particularly at EURO 2020 where, after losing their first two matches, the Danes’ prolific strike force almost took them all the way. In the end, they just fell short, losing to the hosts, England, in extra time. With a number of established European stars in their ranks (Kjær, Maehle and Braithwaite, to name but three), the Danes dominated their World Cup qualifying group, winning nine out of ten matches, scoring 30 goals and conceding just three, and currently top their Nations League group, ahead of rivals France. They have also welcomed back their talisman, Christian Eriksen, who will play a key role in their efforts to overcome not only France, but also Australia and Tunisia. Denmark therefore appear to have every chance of qualifying for the round of 16, at which point their ambition will be to extend their run beyond the quarter-finals, the furthest point they have ever reached at a World Cup – in 1998… in France. Group E: Spain and Germany could go far No group could contain two more prestigious giants of the European game. Spain will be making their 12th consecutive World Cup finals appearance: an extraordinary feat, but one that almost pales into insignificance when compared with Germany’s record, since the 2022 tournament will be their 17th in a row. While history is in the Germans’ favour, the Spanish have enjoyed more recent success. After enduring a sticky patch between 2014 and 2018 (following their EURO 2008, 2010 World Cup and EURO  Spain and Switzerland will have their sights set high.  2012 treble), they were back to their old selves at EURO 2020, when they rediscovered their attacking flair and reached the semi-finals. Their return to form continued in the 2020/21 Nations League (runners-up) and is embodied by the blossoming midfield partnership between Pedri and Gavi, two of the latest in a long line of Spanish playmakers. Luis Enrique’s men look capable of going far in the competition and are favourites to finish ahead of Japan and Costa Rica. The same can be said of Germany, even though they crashed out in the 2018 group stage, victims of the curse of first-round elimination that has hit every reigning champion since 2010. The Germans’ EURO 2020 campaign, in which they were knocked out by England in the round of 16 in Joachim Löw’s last major tournament as coach, was not much better. However, with Hansi Flick at the helm, Die Mannschaft enjoyed their usual stroll through the World Cup qualifiers, with six different players netting three or more  times and an impressive 36 goals scored overall. Their recent 5-2 Nations League win over Italy showed that they are certainly a force to be reckoned with and, having already reached 13 World Cup semi-finals and a record eight finals, it is hard to imagine anything other than a successful run in Qatar. Group F: Can Belgium and Croatia repeat 2018 success? Belgium, who were beaten 1-0 by France in the semi-finals, and Croatia, 4-2 losers against Les Bleus in the final, both enjoyed extraordinary success in 2018. But can they repeat it in 2022? It certainly seems possible where the Belgians and their golden generation are concerned. Belgium have consistently been among the favourites in recent tournaments, with outstanding players (including Lukaku,"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "WORLD CUP 2022  Germany, with eight finals and four world titles already to their name, will want to erase the memories of their first-round elimination in 2018.  De Bruyne and Hazard), an attractive style of play and an impressive goalscoring record to boot… but still they await their first major title. After winning their first four matches at EURO 2020, Roberto Martínez’s team were again knocked out by the eventual winners, Italy, in the quarter-finals, and have become a leading light on the international stage, reaching at least the quarter-finals at the last two World Cups and EUROs. Once again, World Cup qualifying was a walk in the park for the Belgians, raising a whole nation’s hopes of winning the ultimate prize. However, while they can still call on most of their key players from 2018, the same cannot be said of Croatia, who can no longer call on Danijel Subašić, Ivan Rakitić and Mario Mandžukić, among others. Of course, Croatia’s excellent youth system continues to produce new talent and midfield maestro Luka Modrić remains a global superstar, but it is hard to deny that the Croatian team is on something of a downward trajectory. Before securing World Cup qualification thanks to an 81st-minute Russian own goal, the Croats had been eliminated by Spain in the round of 16 at EURO 2020. However, despite a relatively poor run of results, they remain favourites to finish second in the group behind Belgium by seeing off Morocco and Canada.  Group G: Switzerland and Serbia face Brazil (again) The make-up of Group G also produced a sense of déjà vu, since Switzerland and Serbia were also drawn together in the same group at the 2018 World Cup, where they were also joined by Brazil! This time, Cameroon will fill the fourth slot instead of Costa Rica. Switzerland have fonder memories of 2018 than the Serbs, since they managed to hold Brazil off and qualify for the round of 16. A similar outcome seems feasible in 2022, with Xherdan Shaqiri and his team-mates, who will compete in their fifth consecutive World Cup, continuing to deliver top-class performances. Boasting the best defensive record in the qualifying competition (only two goals conceded), the Swiss finished ahead of Italy, demonstrating their ability to hold their own with the world’s leading football nations. At EURO 2020, they knocked out the world champions, France, in the round of 16 before losing to Spain on penalties. Despite never having progressed beyond the quarter-finals at a major tournament, can they go a step further in Qatar? A similar question could be asked of Serbia, who have never reached the knockout stage of a major tournament in their current guise (Yugoslavia’s past achievements excluded). The Serbs, the only European team in Qatar to have  missed EURO 2020, booked their place thanks to a last-minute header by the prolific Aleksandar Mitrović (eight goals in the qualifiers) in their final qualifier against Portugal. Group H: Portugal will need to be on form Having been usurped by Serbia in their qualifying group, Portugal managed to come through the lottery of the play-offs by beating Turkey and then North Macedonia. The Portuguese will therefore be at their sixth consecutive World Cup finals, with Cristiano Ronaldo featuring for the fifth time to equal the record for a player. The Portuguese captain will have one final chance to shine on the world stage, where his record is rather disappointing: seven goals in 17 matches, none in the knockout stages, and a semi-final in 2006 his best achievement. European champions in 2016 and Nations League winners the year after, the Portuguese have dropped a peg or two in recent years (losing in the round of 16 at both the 2018 World Cup and EURO 2020). With a mix of experienced older players and hugely talented youngsters to call on, they certainly deserve to be considered favourites to win a group that also includes Uruguay, Ghana and South Korea. UEFA DIRECT • Q3 2022 – 51"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 52-title-1\" style=\"top:131px; left:59px;\" src=\"/199/en/static/_content/52-title-1.png\">\n        <img class=\"halfScale 52-sub-1\" style=\"top:212px; left:59px;\" src=\"/199/en/static/_content/52-sub-1.png\">\n      ",
    "script": "\n      \n      function onPageEnter() {\n        pg52Anim = new TimelineMax();\n        pg52Anim.fromTo(cOf(\"52-title-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"52-sub-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg52Anim.stop();\n        removeContentLinks()\n      }\n      ",
    "searchText": "EUROPE’S FOOTBALL PITCHES MAPPED A new platform that uses satellite images and artificial intelligence (AI) has made it possible to map more than 250,000 football pitches across Europe, providing national football associations with new development opportunities.  52 – UEFA DIRECT • Q3 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "UEFA GROW  B  ased on the need for more insights and data on football facilities, the UEFA Grow team and the UEFA intelligence centre have developed an AI-driven platform that uses open-source maps and satellite images to identify and classify more than 250,000 football pitches across Europe. Knowledge of the number, locations and types of football pitches present in different areas provides important information to drive the development of football in Europe. Data analysis indicates that there is a positive statistical correlation between the relative number of pitches within a country and the participation rate in that country, which may help associations build a robust pitch development strategy when they consider how to grow the game sustainably. The UEFA pitch mapping tool can differentiate between certain pitch types, such as grass, artificial and concrete  pitches, as well as pinpoint the latitude and longitude of any pitch location. The tool highlights heat maps that show pitch density across Europe, so areas with a high concentration of football pitches can be easily seen. Correlating pitches and local population for better investment Data has also been overlaid to show the population of different countries and regions, showing which nations have a higher number of pitches in relation to their overall or regional population, and which have lower and might therefore consider a plan to develop more infrastructure. The pitch mapping tool will help national associations decide how, where and why investments might be made in developing new facilities to grow football participation levels.  The analysis can be tailored to specific regions to show detailed analyses of the potential local impact of pitch development, as well as showcasing which regions within those nations might require particular attention. All the data from the tool can be exported to provide national associations with further analysis and allow users to carry out comparisons on trendlines in football and the relative importance of pitches to national associations. The UEFA pitch mapping tool is available for all national associations at pitchdetection.uefa.com. Over time, the tool will be enhanced following feedback from national associations, and there are also plans to add in additional data from associations including on clubs and teams. To organise a demo of the tool please get in touch with the UEFA Grow team (uefagrow@uefa.ch).  With the pitch mapping tool, you can zoom in close (Below: a view over Odense in Denmark). The platform provides statistics per country and region, as well as differentiating between pitch types (grass, artificial, concrete, etc.) and their location (schools, sports centres, stadiums, etc.).  UEFA DIRECT • Q3 2022 – 53"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:643px;left:267px;width:136px;height:186px;\">\n        <a href=\"https://uefatechnicalreports.com/\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          addContentLinks()\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": "UEFA NEWS  IN BRIEF  UEFA Youth League holders win Under-20 Intercontinental Cup  Semi-automated offside technology introduced ON 10 AUGUST, semi-automated offside technology (SAOT) was used in a UEFA club competition for the first time at the Super Cup match in Helsinki. The technology will also be used from the group stage in this season’s UEFA Champions League. ”UEFA is constantly looking for new technological solutions to improve the game and support the work of the referees. This innovative system will allow VAR [video assistant referee] teams to determine offside situations quickly and more accurately, enhancing the flow  Technical reports UEFA’S TECHNICAL OBSERVERS have delivered their insights in technical reports on the four major club competitions (UEFA Champions League, UEFA Women’s Champions League, UEFA Europa League and UEFA Europa Conference League). The reports provide comprehensive analyses of the tactical and technical trends: the goals, as well as statistics on pressing, set pieces, passing, possession, goalkeeping, and much more. The reports are available in English, French and German on uefatechnicalreports.com.  54 – UEFA DIRECT • Q3 2022  of the game and the consistency of decisions,” said UEFA’s chief refereeing officer, Roberto Rosetti. The new system uses specialised cameras that are able to track 29 different body points per player. A total of 188 tests have been performed since 2020, including in last season’s men’s Champions League and at the Women’s EURO this summer. “The system is ready to be used in official matches and implemented at each [men’s] Champions League venue,” Rosetti confirmed.  IN THE FIRST MEETING between the winners of the Copa Libertadores U20 and UEFA Youth League, it was the European side that triumphed, but it took some fine saves from Samuel Soares in the Benfica goal to keep out the South American champions. On 21 August, in front of a fervent crowd of 40,579 at the Estadio Centenario in Montevideo, Uruguay, stage for the first World Cup final in 1930, Benfica began promisingly. But a well-organised Peñarol side allowed the Eagles little space to produce the sweeping attacking football with which they defeated Salzburg 6-0 in April’s UEFA Youth League final, though hat-trick scorer that day, Henrique Araújo, was not available due to UEFA Champions League duties. The home side looked dangerous on the break, Máximo Alonso having a shot blocked. Samuel Soares also had to be alert to tip away an inswinging Santiago Homenchenko free-kick and early in the second half he got down well to a Nicolás Rossi strike. Yet it was Benfica who struck with just over 20 minutes left, Luís Semedo pouncing to turn in a flicked-on Cher N’Dour corner, scoring as a substitute just as he did in the UEFA Youth League final. Peñarol looked to respond and Samuel Soares did superbly to deny Homenchenko again as Benfica held on to lift the new trophy."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 54,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg55.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 55-title-1\" style=\"top:131px; left:69px;\" src=\"/199/en/static/_content/55-title-1.png\">\n        <img class=\"halfScale 55-sub-1\" style=\"top:209px; left:71px;\" src=\"/199/en/static/_content/55-sub-1.png\">\n      ",
    "script": "\n      \n      function onPageEnter() {\n        pg55Anim = new TimelineMax();\n        pg55Anim.fromTo(cOf(\"55-title-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"55-sub-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg55Anim.stop();\n        removeContentLinks()\n      }\n      ",
    "searchText": "GIBRALTAR  A NEW BRAND AND A NEW IDENTITY The Gibraltar Football Association and the Gibraltar Football League Association have jointly launched a new brand and identity for Gibraltar’s senior men’s domestic league. BY STEVEN GONZALEZ  T  he competition, which up to now was called the Gibraltar National League, will now be known as the Gibraltar Football League (GFL). As well as being renamed, the league has a new, modern visual identity. The new GFL brand, which encapsulates Gibraltar’s famous Barbary macaque, has been designed and created by local marketing agency The Bulb, which has been working with the Gibraltar FA (GFA) and the Gibraltar Football League Association (GFLA) to capture the concepts and ideas and transform their brief into the new Gibraltar Football League logo. In addition to the new logo, name and identity, a new GFL website will be the online home for everything relating to the league. The site is already up and running in the build-up to the new season’s big kick-off at the end of September. The new-look GFL, which has been fully backed by the Gibraltar FA, is the first in a series of new joint initiatives to be rolled out ahead of the new season, aimed at driving and boosting fan engagement and experiences around the GFL. The Gibraltar FA general secretary, Ivan Robba, said at the GFL launch: “Today is an exciting day for domestic football in Gibraltar, as together with the GFLA we have launched a new brand and identity for the Gibraltar Football League. The launch is testament to a lot of hard work that has been put in by the Gibraltar FA and the GFLA in conjunction with our excellent marketing agency, The Bulb. “The new identity and logo are and will become fundamental pillars in launching Gibraltarian club football onto a whole new level of modern and professional league football, and together with the GFLA and our clubs we will shortly be announcing more exciting projects ahead of the start of the leagues at the end of September.”  The Gibraltar Football League Association said: “The GFLA would like to thank the hard-working design team at The Bulb for developing such an engaging logo and website for the Gibraltar Football League. “We would also like to thank the GFA for providing financial assistance and support, in making this new league launch a reality. “We hope that by enhancing our league’s brand, we will be able to take the next step towards establishing further recognition for Gibraltar in the global football market.” Dylan Trenado, CEO of The Bulb, is immensely proud of the work done by  his team in creating the new identity and image for the GFL: “The first thing we thought about when tackling the rebranding of the Gibraltar Football League was to make it local. We wanted something that would be immediately recognisable, and as you can see, after consultation with the Gibraltar FA and the GFLA, we all settled on our Barbary macaques. We instantly got to work on how we could transform the Barbary macaque into a new, fresh, dynamic and modern look for the league, something which we feel we’ve been able to accomplish. “Nowadays, looking outdated can set you back, so we felt that this new, modern approach would help propel the league forward both at a local level as well as on a wider international stage. We’ve created an engaging logo, which by simply looking at it draws the viewer in, and that is exactly what we were hoping to achieve. Our hope is that this rebrand is the first step to generating increased engagement and excitement about the Gibraltar Football League. There truly are exciting times ahead for football in Gibraltar and we are extremely proud to be playing a part in them.”  GFL  UEFA YOUTH LEAGUE  UEFA DIRECT • Q3 2022 – 55"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 55,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg56.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 56-title-1\" style=\"top:131px; left:59px;\" src=\"/199/en/static/_content/56-title-1.png\">\n        <img class=\"halfScale 56-sub-1\" style=\"top:177px; left:59px;\" src=\"/199/en/static/_content/56-sub-1.png\">\n      ",
    "script": "\n      \n      function onPageEnter() {\n        pg56Anim = new TimelineMax();\n        pg56Anim.fromTo(cOf(\"56-title-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"56-sub-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg56Anim.stop();\n        removeContentLinks()\n      }\n      ",
    "searchText": "LITHUANIA  100 YEARS – 100 GAMES Lithuanian football is marking its 100th anniversary this year and to make this milestone a countrywide celebration, more than 100 games took place during the weekend of 6 to 8 May.  LFF  BY VAIDOTAS KAZLAUSKAS  T  he official start of organised football in the country is said to be 7 May 1922, when the two first official matches in the Lithuanian championship took place in Kaunas. In 1923, Lithuania was accepted into football’s world governing body, FIFA, and after the collapse of the Soviet Union and gaining independence in 1990, membership of UEFA was secured in 1992. To focus all the attention on the game itself, the Lithuanian Football Federation (LFF) decided to hold a festive weekend with more than 100 games over three days. The games involved people of all ages – starting with fun football festivals for young children, moving up to the youth leagues and amateur championships, and finishing with matches in the Lithuanian Cup. “We are very happy with how many people were involved in our celebration.  56 – UEFA DIRECT • Q3 2022  Once again, we could see that football is the most popular sport in the country in terms of participation,’ said the LFF president, Tomas Danilevičius. Not only was there football on view that weekend but also support for Ukraine and its citizens, who are fighting for their future – before every game, the teams posed with Ukrainian flags in a show of support and togetherness. Both the LFF president and the federation’s general secretary, Edgaras Stankevičius, spent the festive weekend travelling the country, visiting different events and congratulating the participants. “I was really overwhelmed by all the positive emotions while visiting different cities and seeing just how much football means to local communities at both the youth and adult football levels. “We wanted to celebrate this jubilee with all the country and I think we really  achieved that,” Stankevičius said. Since 100 years is a big anniversary that reflects the long history of football in our country, not one, but two films are being made to mark the occasion. One reflects the whole 100 years of the development of our football with all of its ups and downs, with the biggest football personalities from those first 100 years sharing their insights on how the sport has developed here. The other film focuses on recent times – it follows the campaign of the men’s senior national football team in the current UEFA Nations League. The camera follows the team at their training camps and documents all the emotions and drama during training, games, everyday life and everything in between. Both films are set to premiere by the end of this year."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 56,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg57.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 57-title\" style=\"top:153px; left:70px;\" src=\"/199/en/static/_content/57-title-1.png\">\n        <img class=\"halfScale 57-sub\" style=\"top:214px; left:72px;\" src=\"/199/en/static/_content/57-sub-1.png\">\n        <img class=\"halfScale 57-title\" style=\"top:547px; left:72px;\" src=\"/199/en/static/_content/57-title-2.png\">\n        <img class=\"halfScale 57-sub\" style=\"top:581px; left:72px;\" src=\"/199/en/static/_content/57-sub-2.png\">\n\n        <div class=\"addContentLink\" style=\"top:131px;left:586px;width:55px;height:13px;\">\n          <a href=\"https://www.fshf.org\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:524px;left:591px;width:51px;height:13px;\">\n          <a href=\"https://www.faf.ad\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg57Anim = new TimelineMax();\n          pg57Anim.staggerFromTo(cOf(\"57-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"57-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg57Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "MEMBER ASSOCIATIONS  ALBANIA  www.fshf.org  FREE SPORTSWEAR FOR EVERY CHILD WHO PLAYS FOOTBALL FATJON KODRA  children, to create the best programmes. Today, about 15,000 children are part of our game and our target is to double that number and this ambitious figure will be achieved through these projects.” The sportswear project will have a direct impact on around 15,000 Albanian families whose children play football. Giving free sportswear to all children who play football, starting from the new season, is expected to assist the growth of the game in Albania and bring more boys and girls closer to the magical world of football. FSHF  The Albanian Football Association has launched a project to provide free sportswear to every child who plays football up to the Under-19 age category. It is a very vital initiative for the development of football in our country. Each set of sportswear consists of a playing uniform, training kit, tracksuit, rain jacket and kit bag. The project will cost €1m per season and the bill will be paid by the Albanian FA, thus significantly reducing the burden on families and also giving all children the opportunity to play football in better conditions. The president of the Albanian FA, Armand Duka, said at the project launch: “It is really exciting to launch this project, which I hope and am sure will greatly help the development of Albanian football. I am convinced that the project will help not only professional football but even  more so amateur football. Football is not just a game, it is not just a competition, it is not just professional football, but it is education. We will continue to work hard to create the best conditions for the  ANDORRA  www.faf.ad  EIGHTH WOMEN’S CAMP This summer, the Andorran Football Federation organised its eighth women’s camp at La Massana training centre, bringing together 80 players to improve their skills, learn new tactical concepts or simply enjoy a new experience, with more than 20 of them not having played football before. The vast majority of the participants were from Andorra, but some also came from Lleida and Barcelona in Spain. All of them enjoyed two training sessions a day, mixing football with other leisure activities such as swimming or excursions in and around Andorra. The players also benefitted from team-building exercises, learning and promoting values directly related to football such as friendship, companionship and respect.  FAF  IVÁN MOURE  UEFA DIRECT • Q3 2022 – 57"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 57,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg58.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 58-title\" style=\"top:154px; left:58px;\" src=\"/199/en/static/_content/58-title-1.png\">\n        <img class=\"halfScale 58-sub\" style=\"top:190px; left:59px;\" src=\"/199/en/static/_content/58-sub-1.png\">\n        <img class=\"halfScale 58-title\" style=\"top:429px; left:58px;\" src=\"/199/en/static/_content/58-title-2.png\">\n        <img class=\"halfScale 58-sub\" style=\"top:464px; left:59px;\" src=\"/199/en/static/_content/58-sub-2.png\">\n\n        <div class=\"addContentLink\" style=\"top:131px;left:574px;width:55px;height:13px;\">\n          <a href=\"https://www.affa.az\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:405px;left:573px;width:55px;height:13px;\">\n          <a href=\"https://www.rbfa.be\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg58Anim = new TimelineMax();\n          pg58Anim.staggerFromTo(cOf(\"58-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"58-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg58Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "MEMBER ASSOCIATIONS  AZERBAIJAN  www.affa.az  A SEMINAR ON THE VAR PROJECT FIRUZ ABDULLA  acquainted with the conditions in the VAR centre and with how the VAR protocol works with the participation of FIFA referees Aliyar Aghayev and Elchin Masiyev, who also gave information about the implementation of the project and answered questions. The document confirming the implementation of VAR was sent to the AFFA by FIFA, which carried out the technological preparation of the VAR system on 13 and 14 July, followed by AFFA  A seminar regarding the video assistant referee (VAR) project of the Association of Football Federations of Azerbaijan (AFFA) was organised for media representatives at the VAR centre located in the Baku Olympic Stadium. VAR project manager Elkhan Samadov explained the system and provided information about the work done so far in terms of the use of VAR in Azerbaijan. Media representatives and commentators from the CBC Sport TV channel, which owns the rights to broadcast matches in the Azerbaijan premier league, got  a successful final evaluation of the referees from 22 to 24 July. The VAR system will be used in the 2022/23 Azerbaijan premier league, which kicked off on 5 August.  BELGIUM  www.rbfa.be  FIRST FOOTBALL MARKETING FORUM MATTEO BALLIAUW, JULES FREMAUT AND KEN STANDAERT  58 – UEFA DIRECT • Q3 2022  field. Therefore, within the mission of its knowledge centre, the association decided to create its own annual sports marketing event with international speakers.   “The ambition of our knowledge centre is to create football-related academic expertise, but also to share sporting, economic and social know-how and new insights to empower our clubs. With that in mind, we are organising the first edition of the Football Marketing Forum in October, with a strong focus this year on sports sponsorship. That world is rapidly changing, partly due to digital developments, and we hope to bring a lot of people together and inspire them at this event,” says Matteo Balliauw, coordinator of the RBFA knowledge centre.  RBFA  The Royal Belgian Football Association (RBFA) is holding its first Football Marketing Forum on 4 October. Under the slogan ‘Winning hearts and minds through sponsorship’, this international event aims to bring together the cream of the Belgian and European business community and several sports marketing experts with representatives of Belgian football clubs, as well as other football associations and other sports. “Our men’s national football team is among the top in the world, but as an association, we also want to play a pioneering role. With this event, we want to inspire the Belgian sports world and provide insight into the latest sports marketing trends,” says Manu Leroy, the RBFA director of marketing and communication. Modern football is much more than bringing together a team of players who can kick a ball well together. In addition to classic ticket or shirt sales, generating revenue through marketing in inventive ways and through well-chosen sponsor partnerships has become an essential part of the game. The RBFA, driven in part by the top performances of the Belgian Red Devils over the past decade, also wants to take a leading role off the  The first edition boasts a host of interesting speakers, including representatives of The Coca-Cola Company, FC Barcelona and Dutch telecommunications company KPN (sponsor of the Eredivisie and the KNVB). For the RBFA, Manu Leroy and men’s national team head coach Roberto Martínez will highlight the path that the football association has taken in terms of marketing with the Belgian Red Devils and the Red Flames. The English FA and Barclays are also set to come and speak about sponsorship in the growing sector of women’s football. “In addition to the keynotes and panel discussions, we will also provide networking opportunities, and thanks to Coca-Cola, FIFA will lend us the official World Cup trophy, along with a former top footballer who won the World Cup himself. With the Football Marketing Forum, we really want to fulfil our role in the football ecosystem and bring together the business world, the academic world as well as sports clubs and national associations,” adds Manu Leroy. To learn more about the football marketing forum and see the programme, visit www.rbfa.be/en/fmf22."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 58,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg59.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 59-title\" style=\"top:153px; left:70px;\" src=\"/199/en/static/_content/59-title-1.png\">\n        <img class=\"halfScale 59-sub\" style=\"top:190px; left:72px;\" src=\"/199/en/static/_content/59-sub-1.png\">\n        <img class=\"halfScale 59-title\" style=\"top:594px; left:72px;\" src=\"/199/en/static/_content/59-title-2.png\">\n        <img class=\"halfScale 59-sub\" style=\"top:679px; left:72px;\" src=\"/199/en/static/_content/59-sub-2.png\">\n\n        <div class=\"addContentLink\" style=\"top:131px;left:577px;width:65px;height:13px;\">\n          <a href=\"https://www.nfsbih.ba\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:571px;left:571px;width:73px;height:13px;\">\n          <a href=\"https://www.bfunion.bg\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg59Anim = new TimelineMax();\n          pg59Anim.staggerFromTo(cOf(\"59-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"59-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg59Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "MEMBER ASSOCIATIONS  BOSNIA AND HERZEGOVINA  www.nfsbih.ba  FOOTBALL AS A TOOL FOR INTEGRATION SLAVICA PECIKOZA  The UEFA-backed project includes different activities for migrants such as preliminary training sessions, education programmes and fun football tournaments. A preliminary training session was held in the middle of August at migrant camps in Hadžići and Blažuj.  NSBIH  The Bosnia and Herzegovina Football Federation, together with the International Organization for Migration (IOM) and the Respekt football school from Sarajevo, has begun implementation of a project to integrate migrants into society through football.  BULGARIA  The idea is to organise further sessions in the area of Una-Sana Canton and other camps in Bosnia and Herzegovina. “The implementation of this project was slowed down significantly because of the pandemic. It is clear that migrants are going through a very difficult time in their lives, and our goal is to make their situation at least a bit easier through football activities. We really appreciate the IOM’s continued support, and that of the Respekt football school as well, whose coaches are working with migrants,” said Ivana Vlaić, the football federation’s project manager. Migrants who would like to continue with regular training sessions will be able to do so at the Respekt football school, whose founder, Emir Hujdur, said: “The last grant from UEFA has further boosted our motivation to contribute to this wonderful project. We would like to give every child the opportunity to play, to play sport, and everyone has the same starting position. We use football as a tool for social inclusion, integration and non-discrimination, and ‘football for all’ is our mission.” www.bfunion.bg  TECHNOLOGY SERVING A COMPLETELY NEW WAY OF FAN ENGAGEMENT The Bulgarian Football Union (BFU) has signed a five-year partnership with Blocksport, a leading Swiss sports tech solutions provider, to create a full digital ecosystem through the launch of a fan engagement app, fan token and non-fungible tokens (NFTs), making it the first football association in the world to fully embrace the power of blockchain technology and tokenisation for the benefit of Bulgarian football and Bulgarian sport as a whole.  The partnership aims to develop new digital ways for fans to become more involved with the national team, starting with the launch of a new interactive app for fans which will see engagement and digitalisation go beyond the borders of Bulgaria. It will be followed by the launch and release of BFU NFTs and eventually the national team’s own fan tokens,  BFU  VICTOR IGNATOV  which will be utility based, i.e. totally non-speculative. UEFA DIRECT • Q3 2022 – 59"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 59,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg60.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 60-title\" style=\"top:154px; left:58px;\" src=\"/199/en/static/_content/60-title-1.png\">\n        <img class=\"halfScale 60-sub\" style=\"top:190px; left:59px;\" src=\"/199/en/static/_content/60-sub-1.png\">\n        <img class=\"halfScale 60-title\" style=\"top:451px; left:58px;\" src=\"/199/en/static/_content/60-title-2.png\">\n        <img class=\"halfScale 60-sub\" style=\"top:511px; left:59px;\" src=\"/199/en/static/_content/60-sub-2.png\">\n\n        <div class=\"addContentLink\" style=\"top:131px;left:564px;width:65px;height:13px;\">\n          <a href=\"https://www.hns-cff.hr\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:428px;left:569px;width:60px;height:13px;\">\n          <a href=\"https://www.fotbal.cz\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg60Anim = new TimelineMax();\n          pg60Anim.staggerFromTo(cOf(\"60-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"60-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg60Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "MEMBER ASSOCIATIONS  CROATIA  www.hns-cff.hr  DEVELOPING YOUTH PLAYERS As part of its new collaboration with football clubs that bring together Croatian communities in the US and Canada, the Croatian Football Federation (HNS) joined forces with clubs Croatia Cleveland (USA) and Croatia Norval (Canada) to organise two football camps in North America this summer, with the camps designed to serve as a vehicle for fostering a strong connection between the HNS and Croatians living abroad and for discovering young players of Croatian heritage. “We saw some very talented players at the camps in Cleveland and Norval, and we hope that working with our  coaches helped them develop their skills. We think this is an excellent opportunity to additionally strengthen the Croatian national team’s presence in North America and to help us connect with young players there,” said the HNS president, Marijan Kustić. On their return from North America, the HNS coaches and technical staff continued to work on the development of young players through youth national team camps for the boys’ and girls’ Under-15 and Under-16 teams, as well as through participating in the Telki Cup with the boys’ Under-17 team. The federation’s player development and  CZECH REPUBLIC  HNS  NIKA BAHTIJAREVIĆ  selection efforts are certain to be further strengthened by the recruitment of Robert Jarni, who has coached numerous senior and youth teams and also played for Croatia at the 1998 World Cup. Jarni previously coached the Croatian men’s Under-19s between 2017 and 2019 and has now taken on the role of head coach of the boys’ Under-17 team. www.fotbal.cz  THE LEGACY OF HOSTING THE EUROPEAN WOMEN’S UNDER-19 CHAMPIONSHIP FINALS After successfully hosting the European Women’s Under-17 Championship final tournament in 2017, it was the turn of the European Women’s Under-19 Championship finals to come to the Czech Republic this year, with the Moravian-Silesian region the location. The Football Association of the Czech Republic (FAČR) hopes that the organisation of such a prestigious event will bring a further increase in interest in women´s football in the country and in the number of active players. “Our organisation of the tournament was at the top level, which is evidenced by the very positive feedback from the participating teams and UEFA. We see the entire tournament as a big investment in the further development of women´s football in the Czech Republic. We firmly believe that the tournament will also help our national team players – help them with their further development in their clubs or subsequent inclusion in the senior national team. The youth national teams should serve as a preparation stage for 60 – UEFA DIRECT • Q3 2022  FACR  MARTIN GREGOR  their future careers in the A team,“ said the FAČR president, Petr Fousek. Many accompanying events were organised for this year’s finals, for which former elite footballer Lucie Voňková and former Czech goalkeeper Jan Laštůvka served as tournament ambassadors. The FAČR grassroots department also prepared a legacy programme designed to encourage more girls to take up the game, particularly those in the 6–14 age range. Women´s football has been experiencing a great boom in recent years and we  would like this trend to continue, not only in the Moravian-Silesian region but throughout the whole country, in cooperation with schools, clubs and our grassroots coaches. Current Czech national team players Barbora Votíková (Paris Saint-Germain) and Andrea Stašková (Atlético Madrid) visited several of the European championship matches, met children there and took part in various activities and competitions in the fan zones and at the stadiums."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 60,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg61.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 61-title\" style=\"top:153px; left:70px;\" src=\"/199/en/static/_content/61-title-1.png\">\n        <img class=\"halfScale 61-sub\" style=\"top:214px; left:72px;\" src=\"/199/en/static/_content/61-sub-1.png\">\n        <img class=\"halfScale 61-title\" style=\"top:522px; left:72px;\" src=\"/199/en/static/_content/61-title-2.png\">\n        <img class=\"halfScale 61-sub\" style=\"top:583px; left:72px;\" src=\"/199/en/static/_content/61-sub-2.png\">\n\n        <div class=\"addContentLink\" style=\"top:131px;left:577px;width:65px;height:13px;\">\n          <a href=\"https://www.thefa.com\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:500px;left:574px;width:68px;height:13px;\">\n          <a href=\"https://www.jalgpall.ee\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg61Anim = new TimelineMax();\n          pg61Anim.staggerFromTo(cOf(\"61-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"61-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg61Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "MEMBER ASSOCIATIONS  ENGLAND  www.thefa.com  FA LEADERSHIP ACADEMY CONTINUES TO INSPIRE AND EMPOWER Between 25 and 28 July, The FA National Youth Council delivered its annual FA Leadership Academy. Returning as an in-person event for the first time since COVID-19, the four-day residential event kick-started a 12-month learning and development programme for 55 youth leaders from diverse backgrounds. The FA National Youth Council – which marks its tenth anniversary this season – is a group of volunteers aged 16–24 whose vision is to ensure that “all young people have meaningful opportunities to develop themselves and positively impact their football community”. The theme for this year’s leadership academy was identity, and delegates explored different aspects of their own identity and what makes them feel like  The FA  AMY HART  they belong in football. The young leaders took part in a series of workshops focused on a range of topics, from communication and conversation through to building relationships and planning for success. Following the residential, all FA Leadership Academy youth leaders will deliver a project within their local football communities to positively impact an area of the game they are passionate about.  ESTONIA  Ayah Abduldaim, one of the youth leaders who took part in this year’s event, said of the experience: “I have been inspired and empowered to go back to my football community and change the lives of others, just like attending the FA Leadership Academy has done for me.” The FA’s national volunteering manager, Ben Grady, said: “The Leadership Academy’s impact comes from the fact that it is designed for young people, by young people. In addition, its impact extends well beyond the four-day residential, as the young leaders are supported to implement a range of projects to help grow the game and make a real difference in their local communities.” To learn more, please visit #FALA22 or @TheFA_NYC on Twitter, Instagram or LinkedIn. www.jalgpall.ee  ESTONIAN AND FINNISH FOOTBALL LEGENDS FACE OFF MAARJA SAULEP  EFA  On the eve of the anniversary of the restoration of Estonia’s independence, on 19 August, a match between legends was held at the A. Le Coq Arena, when a team consisting of former Estonian men’s  national team players hosted former top players of Finland. It was also the farewell match of Enar Jääger, Dmitri Kruglov and Aleksandr Dmitrijev. Jääger made his national team debut in 2002 against New Zealand, coming on in the 69th minute of the match played at A. Le Coq Arena, which Estonia won 3-2. In total, the defender played for the national team 126 times. Kruglov’s first game for the national team was in 2004 away to Latvia, finishing in a 2-2 draw. The winger has a total of 115 caps and four goals to his name. Dmitrijev’s debut took place in 2004 against Moldova, with Estonia winning 1-0. Dmitrijev was in the starting line-up and played 74 minutes. Over the years, the midfielder made 106 appearances for the national team.  When leaving the field in their final match – Kruglov in the 30th minute, Jääger in the 37th minute and Dmitrijev in the 58th minute – the three Estonian football legends received heartfelt applause from the spectators and the players. The opening half of the Estonian v Finnish legends game ended goalless, with neither team managing to create too many dangerous moments. The situation on the scoreboard changed in the 75th minute, when Mika Väyrynen spun the ball from a free-kick with a very accurate shot into the top corner. Estonia also had good opportunities to score, and in the 69th minute Kristen Viikmäe – on 115 caps – skilfully lifted the ball into the net, only for him to be declared offside. The final whistle from legendary referee Eiko Saare marked a 1-0 victory for Finland’s former top players. The legends’ match also had a charitable dimension, with the ticket revenue going to Estonian football clubs for the purchase of defibrillators or resuscitation equipment. UEFA DIRECT • Q3 2022 – 61"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 61,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg62.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 62-title\" style=\"top:154px; left:58px;\" src=\"/199/en/static/_content/62-title-1.png\">\n        <img class=\"halfScale 62-sub\" style=\"top:213px; left:59px;\" src=\"/199/en/static/_content/62-sub-1.png\">\n        <img class=\"halfScale 62-title\" style=\"top:534px; left:58px;\" src=\"/199/en/static/_content/62-title-2.png\">\n        <img class=\"halfScale 62-sub\" style=\"top:595px; left:59px;\" src=\"/199/en/static/_content/62-sub-2.png\">\n\n        <div class=\"addContentLink\" style=\"top:131px;left:562px;width:65px;height:13px;\">\n          <a href=\"https://www.football.fo\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:512px;left:557px;width:71px;height:13px;\">\n          <a href=\"https://www.palloliitto.fi\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg62Anim = new TimelineMax();\n          pg62Anim.staggerFromTo(cOf(\"62-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"62-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg62Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "MEMBER ASSOCIATIONS  FAROE ISLANDS  www.football.fo  REFEREE EXCHANGES BETWEEN NORDIC COUNTRIES For quite a few years, the football associations in the Nordic countries have cooperated in a referee exchange programme. As a part of this cooperation, a female referee from another Nordic country came to the Faroe Islands for the first time to referee a match in the women’s top flight. Twenty-fve-year-old Marit Skurdal from Norway refereed the match between EBS/Skála and 07 Vestur along with her compatriot Niloo Kafili and local assistant referee Heini Viðoy. The idea has always been to mix visiting referees with local referees so that they can share experiences. The Norwegians were very pleased with their visit and felt that the referee exchanges between the Nordic countries is a good opportunity for referees to get some experience of refereeing abroad.  FSF  TERJI NIELSEN  Unfortunately, there are no female referees in the Faroe Islands as yet, but the head of refereeing at the Faroe Islands Football Association, Lassin Isaksen, hopes that  visits like this by female referees from other Nordic countries will inspire young women in the Faroe Islands to take up refereeing.  FINLAND  www.palloliitto.fi  VOLUNTEERS THE HEART OF THE UEFA SUPER CUP In August, Finland hosted its first-ever UEFA club football final when Real Madrid met Eintracht Frankfurt in the UEFA Super Cup at the Helsinki Olympic Stadium. Organising an event as large as the UEFA Super Cup would not have been successful without the contribution of 360 volunteers, whose tasks were related to customer service, accreditations, logistics, transport and media functions, among others. “The volunteers had a massive job, but everything went perfectly in the end – I’m really proud of them! The feedback we have received both from the volunteers and UEFA has been remarkably positive. I want to thank every volunteer who participated for their contribution,” 62 – UEFA DIRECT • Q3 2023  said Silja Ranta, volunteer manager for the Super Cup and the Finnish FA. She was especially happy about the positive atmosphere and team spirit that prevailed among the volunteers. “It was a pleasure to watch how everyone supported each other. Lots of new friendships and networks were born. The volunteers were probably the best team at this event,” she laughed. The scale of the event and its international nature gave many of the Super Cup volunteers lots of exciting new experiences and an opportunity to witness what it takes to organise a top-level European football match. Silja Ranta hopes that, as a result, more people might be encouraged to get involved as volunteers at grassroots level.  FA of Finland  TARU NYLHOLM"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 62,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg63.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 63-title\" style=\"top:153px; left:70px;\" src=\"/199/en/static/_content/63-title-1.png\">\n        <img class=\"halfScale 63-sub\" style=\"top:237px; left:72px;\" src=\"/199/en/static/_content/63-sub-1.png\">\n        <img class=\"halfScale 63-title\" style=\"top:451px; left:72px;\" src=\"/199/en/static/_content/63-title-2.png\">\n        <img class=\"halfScale 63-sub\" style=\"top:487px; left:72px;\" src=\"/199/en/static/_content/63-sub-2.png\">\n\n        <div class=\"addContentLink\" style=\"top:131px;left:591px;width:50px;height:13px;\">\n          <a href=\"https://www.gff.ge\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:428px;left:589px;width:52px;height:13px;\">\n          <a href=\"https://www.dfb.de\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg63Anim = new TimelineMax();\n          pg63Anim.staggerFromTo(cOf(\"63-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"63-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg63Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "MEMBER ASSOCIATIONS  GEORGIA  www.gff.ge  AMPUTEE FOOTBALL JUNIOR CAMP HELD IN TBILISI From 14 to 18 July, Tbilisi hosted an international camp for junior amputee footballers. Youngsters from England, Belgium, Costa Rica, Georgia, Germany, Poland and Türkiye took part in the event. “Football knows no borders. It is important for everyone to be able to play the game and be involved in this process. In 2019, we hosted the first-ever EAFF [European Amputee Football Federation] Champions League, and I am delighted  to see the junior amputee camp take place in Tbilisi this year. I wish all participants the best of luck,” the GFF president, Levan Kobiashvili, said at the closing ceremony. Together with the EAFF president, Mateusz Widlak, he presented certificates to all the participants. The European Amputee Football Federation has been organising  GFF  TAMARA KAPANADZE  international junior amputee camps since 2019, with this camp in Tbilisi the first to be held since the pandemic.  GERMANY  www.dfb.de  DFB CAMPUS ALREADY A HIVE OF ACTIVITY LUCA HERRMANN  Before they had even been officially inaugurated, the national women’s team was the first to make use of the facilities, when head coach Martina Voss-Tecklenburg called up an extended squad to begin preparations for the Women’s EURO at its new Frankfurt base.  DFB  Less than two months after opening its doors on 30 June, German football’s new home is already buzzing with activity. The DFB campus is clearly fulfilling its mission to bring sport, science and administration together under one roof and serve as a place where people meet and share ideas.  The German team’s performance in England proved that this was not a bad way to get the ball rolling. In a captivating tournament, they went all the way to the final before losing to the hosts. Meanwhile, the men’s Under-17 squad became the first national youth team to visit the campus, where they held a short training camp and scouting tournament. The campus is also the new home of the DFB’s coach education activities. Sixteen up-and-coming coaches completed the next stage of their Pro diploma course in Frankfurt in August. On a site of roughly 15 hectares, a building complex 307m long and 18.5m tall at its highest point houses the DFB’s administrative offices and youth academy. The campus also boasts a large indoor football hall, a 33-bedroom hotel for players, a multipurpose futsal hall, three and a half grass pitches and additional training areas. The medical centre, meanwhile, provides first-class treatment and rehabilitation facilities for the players. UEFA DIRECT • Q3 2022 – 63"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 63,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg64.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 64-title\" style=\"top:154px; left:58px;\" src=\"/199/en/static/_content/64-title-1.png\">\n        <img class=\"halfScale 64-sub\" style=\"top:213px; left:59px;\" src=\"/199/en/static/_content/64-sub-1.png\">\n        <img class=\"halfScale 64-title\" style=\"top:416px; left:58px;\" src=\"/199/en/static/_content/64-title-2.png\">\n        <img class=\"halfScale 64-sub\" style=\"top:476px; left:59px;\" src=\"/199/en/static/_content/64-sub-2.png\">\n\n        <div class=\"addContentLink\" style=\"top:131px;left:549px;width:80px;height:13px;\">\n          <a href=\"https://www.football.org.il\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:392px;left:577px;width:51px;height:13px;\">\n          <a href=\"https://www.kff.kz\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg64Anim = new TimelineMax();\n          pg64Anim.staggerFromTo(cOf(\"64-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"64-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg64Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "MEMBER ASSOCIATIONS  ISRAEL  www.football.org.il  WOMEN’S TEAM AT THE SPECIAL OLYMPICS WORLD GAMES EITAN DOTAN  For the first time, an Israeli women’s team will represent our country at the Special Olympics World Games in Berlin in June next year. The head coach will be former Israel women’s international Silvi Jan. Special Olympics, Athena – the centre for the promotion of women’s sport in Israel – and the Israel Football Association jointly announced the establishment of a women’s team to represent Israel at the  games. This historic move has been made possible thanks to the mobilisation of all the bodies together. It will be the first football team for women with cognitive disabilities (Down’s syndrome, autism, cognitive impairment, intellectual and developmental disabilities). The team will train under a professional team led by Silvi Jan, who says: “I am very excited to coach the Special Olympics team and to use my experience as a  professional football player and coach to girls and women. Those who know me know that I have always loved challenges. I may look tough on the outside but I am full of love and giving, especially towards people with special needs. My goal is to prepare them for the World Games and for them to enjoy themselves at the same time. Their success is my success. I believe in them and will do everything I can to win gold at the World Games in Berlin.”  KAZAKHSTAN  www.kff.kz  LARGE-SCALE FOOTBALL FESTIVAL FOR GIRLS A large-scale football festival for girls, My Game, was held in 17 cities across the country. The Kazakhstan Football Federation initiated and organised the event as a way to promote women’s football in the country. Over 3,000 girls aged 9–14 took part in the festival. Experienced coaches of women’s teams, as well as players from women’s football clubs, acted as instructors, demonstrating exercises with the ball, as well as drills to practise coordination and speed. As a result of the project, most of the participants have started playing football in their regional amateur clubs. Currently, women’s football is one of the fastest-growing sports in Kazakhstan, prompting an increase in the number of teams and the level of competition among them. At the end of the festival, all the participants received certificates and souvenirs. The Kazakhstan Football Federation looks forward to organising similar events annually. 64 – UEFA DIRECT • Q3 2023  KFF  PRESS SERVICE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 64,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg65.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 65-title\" style=\"top:153px; left:70px;\" src=\"/199/en/static/_content/65-title-1.png\">\n        <img class=\"halfScale 65-sub\" style=\"top:213px; left:72px;\" src=\"/199/en/static/_content/65-sub-1.png\">\n        <img class=\"halfScale 65-title\" style=\"top:462px; left:72px;\" src=\"/199/en/static/_content/65-title-2.png\">\n        <img class=\"halfScale 65-sub\" style=\"top:523px; left:72px;\" src=\"/199/en/static/_content/65-sub-2.png\">\n\n        <div class=\"addContentLink\" style=\"top:131px;left:596px;width:47px;height:13px;\">\n          <a href=\"https://www.lff.lv\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:439px;left:569px;width:72px;height:13px;\">\n          <a href=\"https://www.mfa.com.mt\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg65Anim = new TimelineMax();\n          pg65Anim.staggerFromTo(cOf(\"65-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"65-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg65Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "MEMBER ASSOCIATIONS  LATVIA  www.lff.lv  MAJOR SPORTS COMPLEX OPENS IN RIGA August saw the opening of the biggest privately owned sports complex in Latvia, which becomes the new home of Latvian champions FK RFS and a major point of football infrastructure in the capital. LNK Sports Park has two natural football pitches along with a designated warm-up area and four artificial football pitches, as well as the necessary infrastructure for other sports. Further football pitches, a multifunctional sports hall and stands for spectators are planned during the second phase of construction, transforming this previously  run-down territory into a modern centre with a stadium capable of staging international fixtures in the very near future. “In order for children to get involved in sport, in order for clubs to be able to develop themselves, modern and accessible infrastructure is a necessity. We can only express great satisfaction for a private initiative of such a scale. It will most definitely have a positive effect on the development of sport in Latvia, especially football,” said Vadims Ļašenko, president of the Latvian Football Federation.  LFF  TOMS ĀRMANIS  MALTA  www.mfa.com.mt  FIRST EDUCATIONAL AND TRAINING PROSPECTUS PUBLISHED The Malta FA’s commitment to raising the standards across all sectors of local football through improved knowledge and expertise has led to the publication of the first learnMFA prospectus. Launched in the first week of August to coincide with the start of the 2022/23 domestic season, the prospectus outlines the educational and training opportunities within the learnMFA programme, which is spearheaded by Matthew Paris, the Malta FA vice-president. The prospectus encompasses a set of educational initiatives in the form of courses in four key areas – administration, finance, coaching and medical – with the ultimate aim being to enhance the personal and professional development of people working within local football, including coaches and coaching candidates, current and prospective administrators, club officials and medical personnel.  MFA  KEVIN AZZOPARDI  Bjorn Vassallo, the Malta FA president, said: “The game of football is constantly evolving, and this process creates new challenges and opportunities. The Malta FA, clubs and member associations have had to adapt and realign their policies, structures and working practices to cope with new demands and realities. This is why the Malta FA has launched a series of educational and knowledge-sharing programmes aimed at the continuous development of football professionals.” The courses planned for this season include sports management programmes  such as the Malta FA Certificate in Football Administration, which is modelled on the UEFA Certificate in Football Management course, as well as courses focusing on anti-money laundering and sports governance. In addition to the coaching courses, ranging from the grassroots leader’s certificate to the UEFA elite youth A diploma, the Malta FA technical centre has broadened the range and variety of courses to cover all the key areas of coaching. Building on the success of the first match analyst course, held last year, the second edition has just been concluded. It comprises three modules – tactics, video analysis and data, and technology and scouting. A total of 24 candidates have successfully completed one of the two match analyst courses, thereby increasing the pool of qualified analysts and further improving the standards of the technical personnel within Maltese football. UEFA DIRECT • Q3 2022 – 65"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 65,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg66.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 66-title\" style=\"top:154px; left:58px;\" src=\"/199/en/static/_content/66-title-1.png\">\n        <img class=\"halfScale 66-sub\" style=\"top:213px; left:59px;\" src=\"/199/en/static/_content/66-sub-1.png\">\n        <img class=\"halfScale 66-title\" style=\"top:548px; left:58px;\" src=\"/199/en/static/_content/66-title-2.png\">\n        <img class=\"halfScale 66-sub\" style=\"top:607px; left:59px;\" src=\"/199/en/static/_content/66-sub-2.png\">\n\n        <div class=\"addContentLink\" style=\"top:129px;left:572px;width:56px;height:13px;\">\n          <a href=\"https://www.fmf.md\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:523px;left:558px;width:70px;height:13px;\">\n          <a href=\"https://www.irishfa.com\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg66Anim = new TimelineMax();\n          pg66Anim.staggerFromTo(cOf(\"66-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"66-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg66Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "MEMBER ASSOCIATIONS  MOLDOVA  www.fmf.md  MOLDOVA WIN PROMOTION TO EURO BEACH SOCCER LEAGUE DIVISION A After winning the regular stage in Division B of the Euro Beach Soccer League in 2021, Moldova did even better this year, winning the Division B promo final on home ground in the beautiful arena at La Izvor Park in Chișinău, where they defeated Türkiye 5-3. Following this remarkable result, Moldova are promoted to Division A next year and also become the first European country to book a place at the 2023 European Games in Poland. Moldova won all of their five matches in the promo tournament and scored 21 goals in the process. The team’s top scorer was captain Grigore Cojocari, with six goals, who was also named the MVP of the tournament. Another of Moldova’s players, Ruslan Istrati, was named best goalkeeper for the second time. Greece’s Andreas Katsoulis was the top scorer in the competition, with eight goals.  FMF  ION BUGA  Over five days, the beach soccer arena in Chișinău hosted 30 matches, in which 212 goals were scored. The Division B promo tournament involved 12 European teams:  England, Denmark, Georgia, Greece, Kazakhstan, Latvia, Lithuania, Malta, Moldova, Norway, Romania and Türkiye, with 133 players taking part.  NORTHERN IRELAND  www.irishfa.com  DEGREE COURSE OPENS UP OPPORTUNITIES IN FOOTBALL  James Goodman  The first cohort of students to graduate from the Football Coaching and Business Management degree course run by the Irish Football Association and Ulster University has been recognised for their talents. Since its inception in 2016, the programme has been making an impact on the football industry in Northern Ireland and local communities. Several of the students have already gained employment in the industry as coaches, performance analysts, football coordinators and administrators. Graduate James Goodman (pictured) said: “I was nervous about enrolling as a mature student, but this course was 66 – UEFA DIRECT • Q3 2022  far better run than the one I did 20 odd years ago. Here it felt like the lecturers really cared about your grades, further development and employment opportunities. With it being part-time, and delivered in blocks, it fitted in well with my family and work life. “The course really helped me to progress my football education, on and off the pitch. My skill set has improved considerably, as has my network of contacts within the local game. I’m now working for a club in the Irish Premiership and have been working at the Irish FA’s Elite Youth Academy in association with UEFA. This degree has opened up opportunities in football that I wouldn’t have got otherwise.”  IFA  NIGEL TILSON  The five-year part-time degree programme also provides opportunities for current players, offering a dual career pathway. A number of current and former Irish League players have enrolled. And two of the first crop of graduates previously represented Northern Ireland at senior international level, including ex-senior women’s international Lyndsay Corry."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 66,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg67.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 67-title\" style=\"top:153px; left:70px;\" src=\"/199/en/static/_content/67-title-1.png\">\n        <img class=\"halfScale 67-sub\" style=\"top:213px; left:72px;\" src=\"/199/en/static/_content/67-sub-1.png\">\n        <img class=\"halfScale 67-title\" style=\"top:547px; left:72px;\" src=\"/199/en/static/_content/67-title-2.png\">\n        <img class=\"halfScale 67-sub\" style=\"top:583px; left:72px;\" src=\"/199/en/static/_content/67-sub-2.png\">\n\n        <div class=\"addContentLink\" style=\"top:131px;left:596px;width:47px;height:13px;\">\n          <a href=\"https://www.fai.ie\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:525px;left:594px;width:48px;height:13px;\">\n          <a href=\"https://www.frf.ro\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg67Anim = new TimelineMax();\n          pg67Anim.staggerFromTo(cOf(\"67-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"67-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg67Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "MEMBER ASSOCIATIONS  REPUBLIC OF IRELAND  www.fai.ie  FAI  CLUB MARK PROGRAMME HELPING DEVELOPMENT OF WOMEN’S GAME GARETH MAHER  More clubs and leagues around the country are now catering for female players, which has led to significant growth in participation numbers as the appetite for women’s football continues to grow. The Football Association of Ireland’s (FAI) Club Mark Programme has played a part in assisting clubs, with 22 clubs starting a women’s section since joining the programme and another 18 growing their number of women’s teams and volunteers. Overall, there are 488 clubs registered with the Club Mark Programme, which helps to improve club structures both on and off the pitch. Clubs have increased their volunteer teams, retained both playing and non-playing members, enhanced their facilities and been successful in applying for various grants and initiatives by proving that governance  and operating structures off the pitch are of a good standard. The Club Mark Programme starts with an entry level award, after which clubs can progress to the one star award. A new two star award is currently being prepared to pilot with clubs before rolling it out nationwide. The programme aims to support clubs in every area, and one of the main issues that clubs have been experiencing is that of setting up the right structures for women’s football. Galway Bohemians, based in Knocknacarra, County Galway, were one such club until they signed up for the programme and worked closely with FAI development officer Emer Flately. Now, Galway Bohemians are thriving, with more girls playing and more coaches getting involved to help out. And this kind of development is being replicated at clubs all around the country.  Barry McGann, FAI club development programme coordinator, said: “The FAI Club Mark Programme has provided a support network to grassroots clubs to help them implement best practice in the governance, management and administration of their club. One of the areas that has been noticeably affected by this is women’s and girls’ football. Some clubs simply did not know where to start in creating the structures required to introduce girls’ football, but with the assistance of the Club Mark Programme and guidance from FAI development officers, they have made significant strides in this area. The development of football for women and girls is massively important to the association, which is why it is a key pillar of the 2022–25 strategy.” https://www.fai.ie/domestic/faiclub-mark  ROMANIA  www.frf.ro  AN ONLINE TOOL FOR YOUTH COACHES PAUL ZAHARIA  In accordance with the FRF technical strategy, approved and launched one year ago, the Romanian Football Federation (FRF) decided to create an online tool exclusively for all Romanian youth coaches, no matter the club or age level with which they are working. The online platform, the FRF Coach, was launched at the federation’s headquarters, attended by around 130 youth coaches, who were there to learn how to use the platform and discover the benefits of using it. The platform, which can be accessed on all devices, contains training plan and exercise models, among other features, which can be adapted to each age group. The platform also allows coaches to create a longer-term training plan.  More than 7,600 exercises are available, an average of around 600 per age group, together with 996 training session models and 121 training plans. The platform was developed in partnership with the Royal Dutch Football Association and Rinus Football, a Dutch company that specialises in offering and implementing software for training sessions to all interested clubs and national associations, from the grassroots level to the very top level. “By applying the FRF technical strategy, we constantly make the player the focus of our attention and of everything we do, with the aim of supporting their technical, tactical, physical and mental development. We are well aware of how important it is to develop children and also of the  fact that training sessions are different for each group, and only by implementing this vision at all levels will we be able to increase the number of players and to support the most talented of them on their way to peak performance,” said Răzvan Burleanu, the FRF president. Former player Vlad Munteanu, who is the FRF’s coach project manager, added: “The FRF Coach means developing a working methodology for all Romanian coaches. It is a digital tool that we are delivering to them free of charge. We are clearly talking about the digitalisation of their work, about a modern way of working.” The next step is to introduce the platform to youth coaches in all the county football associations. UEFA DIRECT • Q3 2022 – 67"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 67,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg68.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 68-title\" style=\"top:154px; left:58px;\" src=\"/199/en/static/_content/68-title-1.png\">\n        <img class=\"halfScale 68-sub\" style=\"top:189px; left:59px;\" src=\"/199/en/static/_content/68-sub-1.png\">\n        <img class=\"halfScale 68-title\" style=\"top:463px; left:58px;\" src=\"/199/en/static/_content/68-title-2.png\">\n        <img class=\"halfScale 68-sub\" style=\"top:523px; left:59px;\" src=\"/199/en/static/_content/68-sub-2.png\">\n\n        <div class=\"addContentLink\" style=\"top:130px;left:542px;width:86px;height:13px;\">\n          <a href=\"https://www.scottishfa.co.uk\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:440px;left:558px;width:70px;height:13px;\">\n          <a href=\"https://www.futbalsfz.sk\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg68Anim = new TimelineMax();\n          pg68Anim.staggerFromTo(cOf(\"68-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"68-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg68Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "MEMBER ASSOCIATIONS  SCOTLAND  www.scottishfa.co.uk  A NEW WOMEN’S CUP COMPETITION ANGUS MACGREGOR  Ahead of the 150th anniversary of Scotland’s national game and the 50th anniversary of the first-ever official Scotland women’s national team match, against England, the Scottish FA has launched an ambitious new national women’s cup competition this season, with both semi-finals and the final taking place at Hampden Park. The Scottish FA launched its bespoke women’s football strategy, Accelerate Our Game, in 2021, with the vision to harness the power of women’s football, by changing perceptions and empowering people to inspire the nation, transform lives and build an inclusive, respected and successful game.  Already, Hampden Park has become the new home of the Scotland women’s national team, the domestic league has been revolutionised in a collaborative process involving the Scottish FA, the Scottish Professional Football League and Scottish women’s football, and the football development team have rolled out the UEFA Playmakers programme in partnership with Disney for girls aged five to eight. Ian Maxwell, chief executive of the Scottish FA, said: “The creation of a new national cup competition is another significant step forward for women’s football in Scotland and we look forward to working with clubs, and broadcast and  SLOVAKIA  commercial partners to create something special 50 years on from the first-ever Scotland women’s national team match and as we look forward to celebrating 150 years of our national game.” Fiona McIntyre, Scottish Women’s Premier League managing director and outgoing Scottish FA head of girls’ and women’s football, added: “At a time when Scottish football prepares to celebrate its rich history, both in the men’s and women’s games, it is appropriate that we commit collectively to bold new competitions that reflect the progress and ambitions for women’s football.” www.futbalsfz.sk  FIRST OFFICIAL SPONSOR FOR THE WOMEN’S LEAGUE The Slovak women’s first league has an official partner for the first time in its history, as introduced to the general public shortly before the start of the 2022/23 season. That partner is the Demisport company, which runs a chain of sports goods stores across Slovakia and the Czech Republic. “It’s a serious partner and, for those who are interested in football and as well for the general public, this is confirmation that women’s football is progressing and growing in our country, both qualitatively and quantitatively,“ said Slovakia men’s international Ján Greguš. The new official sponsor supplies balls for every match, a new trophy and also increased prize money for the league champions as well as for the clubs that finish second and third. The proven format of the competition remains unchanged, with ten participants playing each other home and away to begin with, before the top five play over two rounds for the title and the 68 – UEFA DIRECT • Q3 2022  SFZ  PETER SURIN  bottom five play to stay in the league or face relegation. “We have a close relationship with women’s football. We expect mutual  support and promotion, which will ultimately help the development of women’s football and our company,” said Demisport representative Marek Beseda."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 68,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg69.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 69-title\" style=\"top:153px; left:70px;\" src=\"/199/en/static/_content/69-title-1.png\">\n        <img class=\"halfScale 69-sub\" style=\"top:188px; left:72px;\" src=\"/199/en/static/_content/69-sub-1.png\">\n        <img class=\"halfScale 69-title\" style=\"top:570px; left:72px;\" src=\"/199/en/static/_content/69-title-2.png\">\n        <img class=\"halfScale 69-sub\" style=\"top:606px; left:72px;\" src=\"/199/en/static/_content/69-sub-2.png\">\n\n        <div class=\"addContentLink\" style=\"top:131px;left:573px;width:67px;height:13px;\">\n          <a href=\"https://www.football.ch\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:548px;left:573px;width:67px;height:13px;\">\n          <a href=\"https://www.faw.cymru\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg69Anim = new TimelineMax();\n          pg69Anim.staggerFromTo(cOf(\"69-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"69-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg69Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "MEMBER ASSOCIATIONS  SWITZERLAND  www.football.ch  FOOTBALL’S KEY ROLE IN SOCIAL INTEGRATION MARTINA KÜPFER  This is the conclusion of a two-year scientific study conducted at the University of Berne’s Institute of Sports Science, based on surveys of 42 football clubs, comprising 145 teams and 1,839 members, throughout German- and  SFV  With players from 179 different nationalities in the 1,400 clubs affiliated to the Swiss Football Association, it is clear that football is a significant contributor to social integration in Switzerland.  French-speaking Switzerland. The results show there is huge diversity among Swiss football clubs. On the whole, the research suggests that the social integration of football club members is high among all generations of immigrants. Members tend to be socially connected and familiar with their club’s most important rules and customs, and they identify strongly with their club. All kinds of friendships develop at team level in particular, and many of these continue outside the club. Membership of a football club also helps many people to improve their language skills. “This study proves that football plays a key role in social integration in Switzerland,” said the Swiss FA president, Dominique Blanc. “We want to use the results of this research specifically to advance and improve the development of our affiliated football clubs. The Swiss FA’s vision is to be a pillar of society and the important role our clubs play in social integration shows that we’re succeeding.”  WALES  www.faw.cymru  TACKLING ONLINE SEXUAL HARASSMENT MELISSA PALMER  available on Hwb, the digital teaching and learning platform for schools in Wales. The video is one of a series of three from the FAW which will be published across Hwb, with conversations covering the topics of online misogyny, the importance of challenging attitudes and safely reporting inappropriate behaviour. Wales and Swansea City player Joe Allen said: “It has been shocking to hear how many young girls and women are experiencing online sexual harassment. It has really shown that there is a need for more education on both the topic and scale of things. There is so much work to be done to put an end  FAW  The Football Association of Wales (FAW) and the Welsh government recently came together to launch a campaign video that aims to help tackle the issue of online sexual harassment. The thought-provoking video, Calling Out: Online Sexual Harassment, reveals conversations between Wales international footballers Joe Allen, Lily Woodham, Esther Morgan and Joe Morrell, encouraging young people to speak up about sexual harassment online and the importance of calling out the behaviour. The film promotes a culture of equality and respect, with further advice for families, children and educators  to this behaviour, but I hope that the conversations between myself and my Wales team-mates will encourage people to call out this behaviour and for those who may be suffering it, as tough as it may be, reporting it is vital.” UEFA DIRECT • Q3 2022 – 69"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 69,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg70.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 70-title-1\" style=\"top:270px; left:375px;\" src=\"/199/en/static/_content/70-title-1.png\">\n        <img class=\"halfScale 70-sub-1\" style=\"top:422px; left:59px;\" src=\"/199/en/static/_content/70-sub-1.png\">\n      ",
    "script": "\n      \n      function onPageEnter() {\n        pg70Anim = new TimelineMax();\n        pg70Anim.fromTo(cOf(\"70-title-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"70-sub-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg70Anim.stop();\n        removeContentLinks()\n      }\n      ",
    "searchText": "OBITUARY  UEFA MOURNS HANS BANGERTER UEFA’s general secretary from 1960 to 1988 passed away on 29 July, barely a month after his 98th birthday.  H  ans Bangerter’s talent for languages and passion for sport were the ideal building blocks for a successful career in sports administration that began at the Swiss federal school of gymnastics and sport in Macolin, near the Swiss capital, Berne. One of his responsibilities at that time was to look after foreign guests and when, in 1953, he welcomed a group of European football officials, his expertise and polite approach impressed them so much that they offered him the job of FIFA assistant general secretary. Since football was his favourite sport, he accepted the role without hesitation. Bangerter’s seven-year spell with world football’s governing body taught him everything there was to know about the issues facing international football and its major competitions. When Pierre Delaunay, UEFA’s general secretary, resigned, he was seen as the natural replacement. Once again, it was an offer that Bangerter was delighted to accept, but only on condition that UEFA move its headquarters to Berne. UEFA agreed and never looked back. Bangerter took up his new position on 1 January 1960.  70 – UEFA DIRECT • Q3 2022  Finding its way When Hans Bangerter took the reins, UEFA was still finding its way as the governing body of European football. The inaugural edition of the European Nations’ Cup, the predecessor of the UEFA European Football Championship, was yet to reach its conclusion, while UEFA’s first club competition, the European Champion Clubs’ Cup, was still in its infancy. Considering the enormity of his remit, the tools at Bangerter’s disposal were so limited that current staff of UEFA or any other international organisation would scarcely believe it possible. Nevertheless, initially with the help of two secretaries and a team of staff that grew steadily over the years, the general secretary rose to every challenge that came his way. He showed great diplomacy to reconcile the views of associations from both sides of the Iron Curtain, seamlessly organised a growing number of competitions within tight timeframes, and ensured the quality of refereeing remained high, while at the same time improving the game’s technical standards, dealing with disciplinary matters, organising numerous meetings, and writing the Official Bulletin and the general secretary’s reports.  With such a multitude and variety of responsibilities, Hans Bangerter was clearly not just flexible in his thinking, but also sufficiently strong-minded to impose his ideas to protect football’s interests. He more than fulfilled his mandate, putting UEFA on a solid foundation from which it was able to keep pace with the constant changes in society and football, and overcome all the challenges that cropped up along the way. Recognition Hans Bangerter’s outstanding work was recognised when he was made a UEFA honorary member at the 1992 UEFA Congress in Gothenburg. Bangerter was more than just an outstanding leader, however. He was also blessed with human qualities that made him popular not only among football officials throughout Europe and beyond, but also with his UEFA colleagues, from whom he demanded a great deal but whose efforts he was also quick to praise. In retirement, Hans Bangerter lost none of his passion for football, or his loyalty to UEFA, in whose affairs he continued to take a keen interest. His passing is a source of great sadness for all those lucky enough to have known him."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 70,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg71.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "FORTHCOMING EVENTS  OCTOBER 3 October in Nyon UEFA Women’s Champions League: group stage draw 4/5 October UEFA Champions League: group matches (matchday 3) UEFA Youth League – Champions League path: group matches (matchday 3) 5 October UEFA Youth League – domestic champions path: round 1 (return legs) 6 October UEFA Europa League and UEFA Europa Conference League: group matches (matchday 3) 6 and 11 October 2023 FIFA Women’s World Cup: play-offs 9 October in Frankfurt UEFA EURO 2024: qualifying draw 11/12 October UEFA Champions League: group matches (matchday 4) UEFA Youth League – UEFA Champions League path: group matches (matchday 4) 13 October UEFA Europa League and UEFA Europa Conference League: group matches (matchday 4) 18 October in Bucharest European Under-21 Championship: final round draw 19/20 October UEFA Women's Champions League: group matches (matchday 1)  OBITUARIES • Luciano Nizzola, former president of the Italian Football Federation, died on 20 July at the age of 89. At UEFA, he was a member of the Committee for the European Championship from 1988 to 1992 and of the Non-Amateur Football Committee from 1992 to 1996 and again from 1998 to 2000. • György Szilágyi, life honorary president of the Hungarian Football  25/26 October UEFA Champions League: group matches (matchday 5) UEFA Youth League – UEFA Champions League path: group matches (matchday 5)  7 November in Nyon UEFA Champions League: round of 16 draw UEFA Europa League and UEFA Europa Conference League: play-offs draw  25–30 October UEFA Futsal Champions League: main round  8 November in Nyon UEFA Futsal Champions League: elite round draw UEFA Youth League: play-offs draw  26 October UEFA Youth League – domestic champions path: round 2 (first legs) 26/27 October UEFA Women’s Champions League: group matches (matchday 2) 27 October UEFA Europa League and UEFA Europa Conference League: group matches (matchday 5) 31 October in Saint George Park Women's National Team Coaches Conference NOVEMBER 1/2 November UEFA Champions League: group matches (matchday 6) UEFA Youth League – UEFA Champions League path: group matches (matchday 6) 2 November UEFA Youth League – domestic champions path: round 2 (return legs) 3 November UEFA Europa League and UEFA Europa Conference League: group matches (matchday 6)  Federation, died on 21 July at the age of 92. He was a member of the UEFA Referees Committee from 1972 to 1974 and of the Appeals Body from 1980 to 1982, as well as a long-serving member of the UEFA Youth Committee from 1982 to 2000 and of the Fair Play Committee from 1990 to 2002. He was awarded the UEFA Order of Merit in Ruby in 2004. • Former Football Association of Ireland president and former UEFA vice-­ president Des Casey died on 22 August  23/24 November UEFA Women’s Champions League: group matches (matchday 3) 20 November – 18 December in Qatar FIFA World Cup 22–27 November UEFA Futsal Champions League: elite round DECEMBER 7/8 December UEFA Women’s Champions League: group matches (matchday 4) 15/16 December UEFA Women’s Champions League: group matches (matchday 5) 21/22 December UEFA Women’s Champions League: group matches (matchday 6)  NOTICES • Paul Van den Bulck has been elected as the new president of the Royal Belgian Football Association. • Conrad Kirkwood has been reelected as president of the Irish Football Association.  at the age of 91. He was elected onto the UEFA Executive Committee in 1992, going on to serve as a UEFA vice-president from 2000 to 2002. He was a member of UEFA's Youth Committee from 1986 to 2000, of the Fair Play Committee from 1994 to 1996 and of the Fun Football Committee from 1996 to 2000. In 2001, he received a lifetime achievement award from UEFA for his services to grassroots football and was made an honorary member of UEFA the following year.  UEFA DIRECT • Q3 2022 – 71"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 71,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg72.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "ONLINE ABUSE LEAVES A SCAR"
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    var windowWidth = payload.width;
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    console.log("Update Zoom: " + newZ + ", " + newX + ", " + newY + ", " + context.state.pageScale);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state) {
    return state.activePanel == "Contents";
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contentsEnabled;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoomEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {
      transform: "scale(" + getters.pageContainerZoomLevel * state.pageScale + ")"
    };
    if (state.zoomLevel !== 1) {
      styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";
    } else {
      styleObject.transformOrigin = "0px 0px";
    }
    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// CONCATENATED MODULE: ./src/store/mutations.js


var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }
  console.log("Toggle Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || 2;
  // console.log('update zoom', payload)
  console.log("Update Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  if (state.zoomLevel < 1) {
    state.zoomLevel = 1;
    console.log("Update Zoom2: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    isDoublePage: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("mousewheel", this.mouseWheelHandler);
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed) {
          // console.log("is actually panning")
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.wheelDelta > 0) {
      Publish.goToPreviousSection();
    } else {
      Publish.goToNextSection();
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      console.log("WORKING");
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-198877654-4',
  router: router
});

/* eslint-disable no-new */
window.Publish = new vue_esm["a" /* default */]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "OT+5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TKcf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tnot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UhHM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UrMh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UxE6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z1YF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aKuC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jsA2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kxw3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oXGk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r8RT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vvnJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.d7728265066e0130970f.js